"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToMasterDataDBRecord = exports.mapToMasterDataRecord = exports.masterDataKeys = exports.masterDataDBKeys = void 0;
const O = __importStar(require("fp-ts/Option"));
const function_1 = require("fp-ts/function");
const utils_1 = require("../utils");
exports.masterDataDBKeys = [
    'iso_3166',
    'orgnr',
    'company_master_sys_period',
    'likelihood_to_move_score',
    'legal_entity_type',
    'address',
    'zipcode',
    'city',
    'muncipality',
    'county',
    'region',
    'website',
    'phone',
    'email',
    'registration_date',
    'company_category',
    'company_structure',
    'legal_form',
    'listing_type',
    'description_en',
    'operational_status',
    'owners',
    'key_persons',
    'signatory',
    'parent_company_name',
    'previous_names',
    'accountant_firm',
    'has_private_equity_owner',
    'private_equity_owner',
    'lfy',
    'lrq',
    'ceo',
    'ceo_birth_year',
    'chairman',
    'chairman_birth_year',
    'has_share_issues',
    'number_of_owners',
    'number_of_shares',
    'has_foreign_ultimate_parent',
    'ultimate_parent_company',
    'ultimate_parent_org_no',
    'ultimate_parent_net_sales',
    'company_name',
    'sni_classification',
    'sni_classification_code',
    'financials_updated_date',
    'last_updated',
    'company_keywords',
    'fiscal_year',
    'currency',
    'net_sales',
    'cost_of_sales',
    'gross_profit',
    'administrative_expenses',
    'selling_expenses',
    'other_external_expenses',
    'personel_expenses',
    'ebit',
    'ebita',
    'ebitd',
    'ebitda',
    'depr_amo',
    'depreciation',
    'amortisation',
    'net_financial_income_or_expenses',
    'financial_income',
    'financial_expenses',
    'pre_tax_profit',
    'net_profit',
    'cash_equivalents',
    'acc_rec',
    'inventories',
    'oth_curr_op_ass',
    'curr_fin_ass',
    'total_current_assets',
    'ppe',
    'goodwill_intang_ass',
    'n_curr_fin_rec',
    'oth_n_curr_op_ass',
    'total_non_current_assets',
    'total_assets',
    'acc_pay',
    'curr_fin_liab',
    'post_empl_liab',
    'oth_curr_op_liab',
    'total_current_liabilities',
    'oth_n_curr_op_liab',
    'n_curr_fin_liab',
    'total_non_curr_liab',
    'sharehold_eq',
    'retained_earnings',
    'min_int',
    'total_equity',
    'dividends',
    'cash_flow_before_fin_act',
    'cash_flow_operating',
    'ebit_margin',
    'ebitda_margin',
    'pre_tax_profit_margin',
    'net_profit_margin',
    'roe',
    'net_capex',
    'net_debt',
    'market_cap',
    'annual_report_number_of_employees',
    'fiscal_year_length',
    'lfy_month',
    'net_change_in_cash',
    'net_sales_growth',
    'cagr',
    'cagr3',
    'ebit_growth',
    'cagr3ebit',
    'cagrebit',
    'ebitda_growth',
    'net_profit_growth',
    'eps',
    'equity_ratio',
    'net_debt_to_ebit',
    'net_debt_to_ebitda',
    'net_debt_to_equity',
    'ev_to_ebit',
    'ev_to_ebitda',
    'ev_to_net_sales',
    'pe',
    'ev',
    'pbv',
    'annual_report_employee_growth',
    'active_jobposts',
    'domain_is_verified',
    'domain',
    'final_url',
    'error',
    'page_load_time_tti',
    'domain_sys_period',
    'ip_address',
    'analytics_ua',
    'analytics_ga4',
    'analytics_fb',
    'gconvp_account',
    'adobe_account',
    'org_image',
    'sitemaps',
    'cookie_consent',
    'platform',
    'server',
    'host',
    'domain_keywords',
    'description',
    'description_words',
    'description_chars',
    'hosting_provider',
    'hosting_region',
    'is_ecommerce',
    'ecommerce_platform',
    'tool_cookiebot',
    'tool_cookielaw',
    'tool_onetrust',
    'tool_doubleclick',
    'tool_hotjar',
    'tool_optimizely',
    'tool_ebbot',
    'tool_intercom',
    'tool_klaviyo',
    'tool_hubspot',
    'tool_marketo',
    'tool_salesforce',
    'tool_trustpilot',
    'tool_custobar',
    'tool_voyado',
    'tool_godaddy',
    'tool_shopify',
    'tool_squarespace',
    'tool_wix',
    'tool_wordpress',
    'tool_seenthis',
    'tool_yotpo',
    'tool_apprl',
    'tool_criteo',
    'tool_reco',
    'requested_hosts',
    'analytics_gtm',
    'analytics_aw',
    'tool_googletagmanager',
    'size_document',
    'size_script',
    'size_stylesheet',
    'size_image',
    'size_media',
    'title',
    'title_words',
    'title_chars',
    'favicon',
    'canonical',
    'robots',
    'noindex',
    'internal_links',
    'external_links',
    'analytics_mo',
    'lang',
    'analytics_adobe',
    'colors_font',
    'colors_page',
    'colors_svg',
    'access_violation_score',
    'violations',
    'img_alt_ratio',
    'analytics_opt',
    'analytics_amplitude',
    'analytics_snowplow',
    'trackers_before_consent',
    'trackers_before_consent_count',
    'web_vitals_ttfb',
    'web_vitals_fcp',
    'web_vitals_lcp',
    'web_vitals_cls',
    'web_vitals_tti',
    'web_vitals_inp',
    'detected_languages',
    'language_count',
    'h_1_content',
    'h_1_content_words',
    'h_1_content_chars',
    'h_1_count',
    'h_2_count',
    'h_3_count',
    'sitemap',
    'sitemap_count',
    'sitemap_url_count',
    'dns_a',
    'dns_aaaa',
    'dns_ns',
    'dns_soa',
    'dns_mx',
    'email_provider',
    'dns_spf',
    'dns_dmarc',
    'dns_dmarc_level',
    'dns_dmarc_details',
    'dns_dkim',
    'dns_dkim_selector',
    'dns_dkim_level',
    'dns_dkim_details',
    'dns_verifications',
    'size_font',
    'size_xhr',
    'size_ping',
    'size_fetch',
    'size_other',
    'x_robots_tag',
    'framework',
    'cookies',
    'has_schema_script',
    'img_count',
    'img_alt_count',
    'img_missing_alt_count',
    'img_title_count',
    'snapchat_handle',
    'linkedin_is_verified',
    'linkedin_id',
    'linkedin_domain',
    'linkedin_industry',
    'linkedin_number_of_employees',
    'linkedin_all_employee_growth_3_months',
    'linkedin_all_employee_growth_6_months',
    'linkedin_all_employee_growth_1_year',
    'linkedin_all_employee_growth_2_years',
    'number_of_employees',
    'number_of_employees_source',
    'identified_orgnr_count',
    'identified_orgnr_delta_6m',
    'identified_orgnr_delta_1y',
    'identified_orgnr_delta_3y',
    'identified_orgnr_delta_5y',
    'company_buzz_count',
    'company_buzz_is_raising_capital',
    'company_buzz_is_ipo',
    'company_buzz_is_merger',
    'company_buzz_is_moving',
    'company_buzz_is_hiring',
    'company_buzz_is_firing',
    'company_buzz_is_closing',
    'company_buzz_is_opening',
    'company_buzz_is_expanding',
    'company_buzz_is_downsizing',
    'company_buzz_is_restructuring',
    'company_buzz_is_new_product_intro',
    'company_buzz_has_moved',
    'company_buzz_is_changing_ceo',
    'company_buzz_is_changing_board',
    'company_buzz_is_changing_management_team',
    'company_buzz_is_growth_geog',
    'company_buzz_is_growth_seg',
    'company_buzz_is_pricing_model',
    'company_buzz_is_partnership',
    'company_buzz_is_m_and_a',
    'company_buzz_is_divest',
    'company_buzz_is_cost_save',
    'company_buzz_is_restruct',
    'company_buzz_is_layoff',
    'company_buzz_is_hire_plan',
    'company_buzz_is_leadership',
    'company_buzz_is_capex_scale',
    'company_buzz_is_supply_chain',
    'company_buzz_is_digi_ai',
    'company_buzz_is_esg_target',
    'company_buzz_is_esg_event',
    'company_buzz_is_reg_change',
    'company_buzz_is_litigation',
    'company_buzz_is_fin_raise',
    'company_buzz_is_div_policy',
    'company_buzz_is_rev_guide',
    'company_buzz_is_rev_mix',
    'company_buzz_is_cust_mega',
    'company_buzz_is_risk_macro',
    'ml_likely_to_move_probability',
    'ml_is_likely_to_move',
    'move_in_date_current_office',
    'move_date_or_lease_expiration_date',
    'move_date_or_lease_expiration_date_is_within_one_year',
    'move_date_or_lease_expiration_date_has_passed',
    'is_more_than_5_years_since_move_in_date_current_office',
    'workspace_size_in_m2',
    'workspace_size_in_m2_per_employee',
    'nornorm_web_visitors_lead_quality',
    'nornorm_web_visitors_number_of_visits',
    'nornorm_web_visitors_country_code',
    'nornorm_web_visitors_last_visit_date',
    'nornorm_web_visitors_first_visit_date',
    'active_jobposts_per_employee',
    '_6_sense_phone',
    '_6_sense_city',
    '_6_sense_description',
    '_6_sense_company_type',
    '_6_sense_industry',
    '_6_sense_continent',
    '_6_sence_employee_range',
    '_6_sense_naics',
    '_6_sense_products_or_services',
    '_6_sense_sic',
    '_6_sense_stock_exchange',
    '_6_sense_stock_symbol',
    '_6_sense_web_technologies',
    '_6_sense_total_funding_range',
    '_6_sense_year_founded',
    'percent_employees_with_more_than_10_years_experience',
    'has_on_site_requirements',
    'recent_funding',
    'nornorm_keyword_search',
    'nornorm_researched_office',
    'nornorm_researched_furniture',
    'looking_for_office',
    'is_sitting_on_co_working_space',
    'lease_expiration_date',
    'lease_expiration_date_is_within_one_year',
    'nornorm_website_visitor',
    'number_of_addresses',
    'apollo_name',
    'apollo_country',
    'apollo_founded_year',
    'apollo_publicly_traded_symbol',
    'apollo_publicly_traded_exchange',
    'apollo_latest_funding_stage',
    'apollo_latest_funding_round_date',
    'apollo_total_funding',
    'apollo_total_funding_printed',
    'apollo_engineering_head_count_current',
    'apollo_sales_head_count_current',
    'apollo_support_head_count_current',
    'apollo_marketing_head_count_current',
    'apollo_human_resources_head_count_current',
    'apollo_education_head_count_current',
    'apollo_media_and_communication_head_count_current',
    'apollo_consulting_head_count_current',
    'apollo_operations_head_count_current',
    'apollo_finance_head_count_current',
    'apollo_product_management_head_count_current',
    'apollo_business_development_head_count_current',
    'apollo_information_technology_head_count_current',
    'apollo_data_science_head_count_current',
    'apollo_arts_and_design_head_count_current',
    'apollo_entrepreneurship_head_count_current',
    'apollo_administrative_head_count_current',
    'apollo_legal_head_count_current',
    'apollo_accounting_head_count_current',
    'apollo_total_head_count_current',
    'apollo_engineering_head_count_1_month_ago',
    'apollo_sales_head_count_1_month_ago',
    'apollo_support_head_count_1_month_ago',
    'apollo_marketing_head_count_1_month_ago',
    'apollo_human_resources_head_count_1_month_ago',
    'apollo_education_head_count_1_month_ago',
    'apollo_media_and_communication_head_count_1_month_ago',
    'apollo_consulting_head_count_1_month_ago',
    'apollo_operations_head_count_1_month_ago',
    'apollo_finance_head_count_1_month_ago',
    'apollo_product_management_head_count_1_month_ago',
    'apollo_business_development_head_count_1_month_ago',
    'apollo_information_technology_head_count_1_month_ago',
    'apollo_data_science_head_count_1_month_ago',
    'apollo_arts_and_design_head_count_1_month_ago',
    'apollo_entrepreneurship_head_count_1_month_ago',
    'apollo_administrative_head_count_1_month_ago',
    'apollo_legal_head_count_1_month_ago',
    'apollo_accounting_head_count_1_month_ago',
    'apollo_total_head_count_1_month_ago',
    'apollo_engineering_head_count_3_months_ago',
    'apollo_sales_head_count_3_months_ago',
    'apollo_support_head_count_3_months_ago',
    'apollo_marketing_head_count_3_months_ago',
    'apollo_human_resources_head_count_3_months_ago',
    'apollo_education_head_count_3_months_ago',
    'apollo_media_and_communication_head_count_3_months_ago',
    'apollo_consulting_head_count_3_months_ago',
    'apollo_operations_head_count_3_months_ago',
    'apollo_finance_head_count_3_months_ago',
    'apollo_product_management_head_count_3_months_ago',
    'apollo_business_development_head_count_3_months_ago',
    'apollo_information_technology_head_count_3_months_ago',
    'apollo_data_science_head_count_3_months_ago',
    'apollo_arts_and_design_head_count_3_months_ago',
    'apollo_entrepreneurship_head_count_3_months_ago',
    'apollo_administrative_head_count_3_months_ago',
    'apollo_legal_head_count_3_months_ago',
    'apollo_accounting_head_count_3_months_ago',
    'apollo_total_head_count_3_months_ago',
    'apollo_engineering_head_count_6_months_ago',
    'apollo_sales_head_count_6_months_ago',
    'apollo_support_head_count_6_months_ago',
    'apollo_marketing_head_count_6_months_ago',
    'apollo_human_resources_head_count_6_months_ago',
    'apollo_education_head_count_6_months_ago',
    'apollo_media_and_communication_head_count_6_months_ago',
    'apollo_consulting_head_count_6_months_ago',
    'apollo_operations_head_count_6_months_ago',
    'apollo_finance_head_count_6_months_ago',
    'apollo_product_management_head_count_6_months_ago',
    'apollo_business_development_head_count_6_months_ago',
    'apollo_information_technology_head_count_6_months_ago',
    'apollo_data_science_head_count_6_months_ago',
    'apollo_arts_and_design_head_count_6_months_ago',
    'apollo_entrepreneurship_head_count_6_months_ago',
    'apollo_administrative_head_count_6_months_ago',
    'apollo_legal_head_count_6_months_ago',
    'apollo_accounting_head_count_6_months_ago',
    'apollo_total_head_count_6_months_ago',
    'apollo_engineering_head_count_9_months_ago',
    'apollo_sales_head_count_9_months_ago',
    'apollo_support_head_count_9_months_ago',
    'apollo_marketing_head_count_9_months_ago',
    'apollo_human_resources_head_count_9_months_ago',
    'apollo_education_head_count_9_months_ago',
    'apollo_media_and_communication_head_count_9_months_ago',
    'apollo_consulting_head_count_9_months_ago',
    'apollo_operations_head_count_9_months_ago',
    'apollo_finance_head_count_9_months_ago',
    'apollo_product_management_head_count_9_months_ago',
    'apollo_business_development_head_count_9_months_ago',
    'apollo_information_technology_head_count_9_months_ago',
    'apollo_data_science_head_count_9_months_ago',
    'apollo_arts_and_design_head_count_9_months_ago',
    'apollo_entrepreneurship_head_count_9_months_ago',
    'apollo_administrative_head_count_9_months_ago',
    'apollo_legal_head_count_9_months_ago',
    'apollo_accounting_head_count_9_months_ago',
    'apollo_total_head_count_9_months_ago',
    'apollo_engineering_head_count_12_months_ago',
    'apollo_sales_head_count_12_months_ago',
    'apollo_support_head_count_12_months_ago',
    'apollo_marketing_head_count_12_months_ago',
    'apollo_human_resources_head_count_12_months_ago',
    'apollo_education_head_count_12_months_ago',
    'apollo_media_and_communication_head_count_12_months_ago',
    'apollo_consulting_head_count_12_months_ago',
    'apollo_operations_head_count_12_months_ago',
    'apollo_finance_head_count_12_months_ago',
    'apollo_product_management_head_count_12_months_ago',
    'apollo_business_development_head_count_12_months_ago',
    'apollo_information_technology_head_count_12_months_ago',
    'apollo_data_science_head_count_12_months_ago',
    'apollo_arts_and_design_head_count_12_months_ago',
    'apollo_entrepreneurship_head_count_12_months_ago',
    'apollo_administrative_head_count_12_months_ago',
    'apollo_legal_head_count_12_months_ago',
    'apollo_accounting_head_count_12_months_ago',
    'apollo_total_head_count_12_months_ago',
    'apollo_engineering_head_count_growth_1_month',
    'apollo_sales_head_count_growth_1_month',
    'apollo_support_head_count_growth_1_month',
    'apollo_marketing_head_count_growth_1_month',
    'apollo_human_resources_head_count_growth_1_month',
    'apollo_education_head_count_growth_1_month',
    'apollo_media_and_communication_head_count_growth_1_month',
    'apollo_consulting_head_count_growth_1_month',
    'apollo_operations_head_count_growth_1_month',
    'apollo_finance_head_count_growth_1_month',
    'apollo_product_management_head_count_growth_1_month',
    'apollo_business_development_head_count_growth_1_month',
    'apollo_information_technology_head_count_growth_1_month',
    'apollo_data_science_head_count_growth_1_month',
    'apollo_arts_and_design_head_count_growth_1_month',
    'apollo_entrepreneurship_head_count_growth_1_month',
    'apollo_administrative_head_count_growth_1_month',
    'apollo_legal_head_count_growth_1_month',
    'apollo_accounting_head_count_growth_1_month',
    'apollo_total_head_count_growth_1_month',
    'apollo_engineering_head_count_growth_3_months',
    'apollo_sales_head_count_growth_3_months',
    'apollo_support_head_count_growth_3_months',
    'apollo_marketing_head_count_growth_3_months',
    'apollo_human_resources_head_count_growth_3_months',
    'apollo_education_head_count_growth_3_months',
    'apollo_media_and_communication_head_count_growth_3_months',
    'apollo_consulting_head_count_growth_3_months',
    'apollo_operations_head_count_growth_3_months',
    'apollo_finance_head_count_growth_3_months',
    'apollo_product_management_head_count_growth_3_months',
    'apollo_business_development_head_count_growth_3_months',
    'apollo_information_technology_head_count_growth_3_months',
    'apollo_data_science_head_count_growth_3_months',
    'apollo_arts_and_design_head_count_growth_3_months',
    'apollo_entrepreneurship_head_count_growth_3_months',
    'apollo_administrative_head_count_growth_3_months',
    'apollo_legal_head_count_growth_3_months',
    'apollo_accounting_head_count_growth_3_months',
    'apollo_total_head_count_growth_3_months',
    'apollo_engineering_head_count_growth_6_months',
    'apollo_sales_head_count_growth_6_months',
    'apollo_support_head_count_growth_6_months',
    'apollo_marketing_head_count_growth_6_months',
    'apollo_human_resources_head_count_growth_6_months',
    'apollo_education_head_count_growth_6_months',
    'apollo_media_and_communication_head_count_growth_6_months',
    'apollo_consulting_head_count_growth_6_months',
    'apollo_operations_head_count_growth_6_months',
    'apollo_finance_head_count_growth_6_months',
    'apollo_product_management_head_count_growth_6_months',
    'apollo_business_development_head_count_growth_6_months',
    'apollo_information_technology_head_count_growth_6_months',
    'apollo_data_science_head_count_growth_6_months',
    'apollo_arts_and_design_head_count_growth_6_months',
    'apollo_entrepreneurship_head_count_growth_6_months',
    'apollo_administrative_head_count_growth_6_months',
    'apollo_legal_head_count_growth_6_months',
    'apollo_accounting_head_count_growth_6_months',
    'apollo_total_head_count_growth_6_months',
    'apollo_engineering_head_count_growth_9_months',
    'apollo_sales_head_count_growth_9_months',
    'apollo_support_head_count_growth_9_months',
    'apollo_marketing_head_count_growth_9_months',
    'apollo_human_resources_head_count_growth_9_months',
    'apollo_education_head_count_growth_9_months',
    'apollo_media_and_communication_head_count_growth_9_months',
    'apollo_consulting_head_count_growth_9_months',
    'apollo_operations_head_count_growth_9_months',
    'apollo_finance_head_count_growth_9_months',
    'apollo_product_management_head_count_growth_9_months',
    'apollo_business_development_head_count_growth_9_months',
    'apollo_information_technology_head_count_growth_9_months',
    'apollo_data_science_head_count_growth_9_months',
    'apollo_arts_and_design_head_count_growth_9_months',
    'apollo_entrepreneurship_head_count_growth_9_months',
    'apollo_administrative_head_count_growth_9_months',
    'apollo_legal_head_count_growth_9_months',
    'apollo_accounting_head_count_growth_9_months',
    'apollo_total_head_count_growth_9_months',
    'apollo_engineering_head_count_growth_12_months',
    'apollo_sales_head_count_growth_12_months',
    'apollo_support_head_count_growth_12_months',
    'apollo_marketing_head_count_growth_12_months',
    'apollo_human_resources_head_count_growth_12_months',
    'apollo_education_head_count_growth_12_months',
    'apollo_media_and_communication_head_count_growth_12_months',
    'apollo_consulting_head_count_growth_12_months',
    'apollo_operations_head_count_growth_12_months',
    'apollo_finance_head_count_growth_12_months',
    'apollo_product_management_head_count_growth_12_months',
    'apollo_business_development_head_count_growth_12_months',
    'apollo_information_technology_head_count_growth_12_months',
    'apollo_data_science_head_count_growth_12_months',
    'apollo_arts_and_design_head_count_growth_12_months',
    'apollo_entrepreneurship_head_count_growth_12_months',
    'apollo_administrative_head_count_growth_12_months',
    'apollo_legal_head_count_growth_12_months',
    'apollo_accounting_head_count_growth_12_months',
    'apollo_total_head_count_growth_12_months',
    'prv_applicant_has_trademark',
    'prv_applicant_trademark_count_total',
    'prv_applicant_trademark_count_active',
    'prv_applicant_trademarks_last_3m_count',
    'prv_applicant_trademarks_last_12m_count',
    'prv_applicant_applied_last_3m',
    'prv_applicant_applied_last_12m',
    'prv_applicant_latest_application_date',
    'prv_applicant_latest_status',
    'prv_applicant_nice_classes',
    'prv_applicant_nice_class_count',
    'prv_applicant_top_marks',
    'prv_applicant_next_renewal_date',
    'prv_applicant_mapped_count',
    'prv_applicant_mapping_method',
    'prv_applicant_last_mapped_at',
];
exports.masterDataKeys = [
    'iso3166',
    'orgnr',
    'companyMasterSysPeriod',
    'likelihoodToMoveScore',
    'legalEntityType',
    'address',
    'zipcode',
    'city',
    'muncipality',
    'county',
    'region',
    'website',
    'phone',
    'email',
    'registrationDate',
    'companyCategory',
    'companyStructure',
    'legalForm',
    'listingType',
    'descriptionEn',
    'operationalStatus',
    'owners',
    'keyPersons',
    'signatory',
    'parentCompanyName',
    'previousNames',
    'accountantFirm',
    'hasPrivateEquityOwner',
    'privateEquityOwner',
    'lfy',
    'lrq',
    'ceo',
    'ceoBirthYear',
    'chairman',
    'chairmanBirthYear',
    'hasShareIssues',
    'numberOfOwners',
    'numberOfShares',
    'hasForeignUltimateParent',
    'ultimateParentCompany',
    'ultimateParentOrgNo',
    'ultimateParentNetSales',
    'companyName',
    'sniClassification',
    'sniClassificationCode',
    'financialsUpdatedDate',
    'lastUpdated',
    'companyKeywords',
    'fiscalYear',
    'currency',
    'netSales',
    'costOfSales',
    'grossProfit',
    'administrativeExpenses',
    'sellingExpenses',
    'otherExternalExpenses',
    'personelExpenses',
    'ebit',
    'ebita',
    'ebitd',
    'ebitda',
    'deprAmo',
    'depreciation',
    'amortisation',
    'netFinancialIncomeOrExpenses',
    'financialIncome',
    'financialExpenses',
    'preTaxProfit',
    'netProfit',
    'cashEquivalents',
    'accRec',
    'inventories',
    'othCurrOpAss',
    'currFinAss',
    'totalCurrentAssets',
    'ppe',
    'goodwillIntangAss',
    'nCurrFinRec',
    'othNCurrOpAss',
    'totalNonCurrentAssets',
    'totalAssets',
    'accPay',
    'currFinLiab',
    'postEmplLiab',
    'othCurrOpLiab',
    'totalCurrentLiabilities',
    'othNCurrOpLiab',
    'nCurrFinLiab',
    'totalNonCurrLiab',
    'shareholdEq',
    'retainedEarnings',
    'minInt',
    'totalEquity',
    'dividends',
    'cashFlowBeforeFinAct',
    'cashFlowOperating',
    'ebitMargin',
    'ebitdaMargin',
    'preTaxProfitMargin',
    'netProfitMargin',
    'roe',
    'netCapex',
    'netDebt',
    'marketCap',
    'annualReportNumberOfEmployees',
    'fiscalYearLength',
    'lfyMonth',
    'netChangeInCash',
    'netSalesGrowth',
    'cagr',
    'cagr3',
    'ebitGrowth',
    'cagr3ebit',
    'cagrebit',
    'ebitdaGrowth',
    'netProfitGrowth',
    'eps',
    'equityRatio',
    'netDebtToEbit',
    'netDebtToEbitda',
    'netDebtToEquity',
    'evToEbit',
    'evToEbitda',
    'evToNetSales',
    'pe',
    'ev',
    'pbv',
    'annualReportEmployeeGrowth',
    'activeJobposts',
    'domainIsVerified',
    'domain',
    'finalUrl',
    'error',
    'pageLoadTimeTti',
    'domainSysPeriod',
    'ipAddress',
    'analyticsUa',
    'analyticsGa4',
    'analyticsFb',
    'gconvpAccount',
    'adobeAccount',
    'orgImage',
    'sitemaps',
    'cookieConsent',
    'platform',
    'server',
    'host',
    'domainKeywords',
    'description',
    'descriptionWords',
    'descriptionChars',
    'hostingProvider',
    'hostingRegion',
    'isEcommerce',
    'ecommercePlatform',
    'toolCookiebot',
    'toolCookielaw',
    'toolOnetrust',
    'toolDoubleclick',
    'toolHotjar',
    'toolOptimizely',
    'toolEbbot',
    'toolIntercom',
    'toolKlaviyo',
    'toolHubspot',
    'toolMarketo',
    'toolSalesforce',
    'toolTrustpilot',
    'toolCustobar',
    'toolVoyado',
    'toolGodaddy',
    'toolShopify',
    'toolSquarespace',
    'toolWix',
    'toolWordpress',
    'toolSeenthis',
    'toolYotpo',
    'toolApprl',
    'toolCriteo',
    'toolReco',
    'requestedHosts',
    'analyticsGtm',
    'analyticsAw',
    'toolGoogletagmanager',
    'sizeDocument',
    'sizeScript',
    'sizeStylesheet',
    'sizeImage',
    'sizeMedia',
    'title',
    'titleWords',
    'titleChars',
    'favicon',
    'canonical',
    'robots',
    'noindex',
    'internalLinks',
    'externalLinks',
    'analyticsMo',
    'lang',
    'analyticsAdobe',
    'colorsFont',
    'colorsPage',
    'colorsSvg',
    'accessViolationScore',
    'violations',
    'imgAltRatio',
    'analyticsOpt',
    'analyticsAmplitude',
    'analyticsSnowplow',
    'trackersBeforeConsent',
    'trackersBeforeConsentCount',
    'webVitalsTtfb',
    'webVitalsFcp',
    'webVitalsLcp',
    'webVitalsCls',
    'webVitalsTti',
    'webVitalsInp',
    'detectedLanguages',
    'languageCount',
    'h1Content',
    'h1ContentWords',
    'h1ContentChars',
    'h1Count',
    'h2Count',
    'h3Count',
    'sitemap',
    'sitemapCount',
    'sitemapUrlCount',
    'dnsA',
    'dnsAaaa',
    'dnsNs',
    'dnsSoa',
    'dnsMx',
    'emailProvider',
    'dnsSpf',
    'dnsDmarc',
    'dnsDmarcLevel',
    'dnsDmarcDetails',
    'dnsDkim',
    'dnsDkimSelector',
    'dnsDkimLevel',
    'dnsDkimDetails',
    'dnsVerifications',
    'sizeFont',
    'sizeXhr',
    'sizePing',
    'sizeFetch',
    'sizeOther',
    'xRobotsTag',
    'framework',
    'cookies',
    'hasSchemaScript',
    'imgCount',
    'imgAltCount',
    'imgMissingAltCount',
    'imgTitleCount',
    'snapchatHandle',
    'linkedinIsVerified',
    'linkedinId',
    'linkedinDomain',
    'linkedinIndustry',
    'linkedinNumberOfEmployees',
    'linkedinAllEmployeeGrowth3Months',
    'linkedinAllEmployeeGrowth6Months',
    'linkedinAllEmployeeGrowth1Year',
    'linkedinAllEmployeeGrowth2Years',
    'numberOfEmployees',
    'numberOfEmployeesSource',
    'identifiedOrgnrCount',
    'identifiedOrgnrDelta6m',
    'identifiedOrgnrDelta1y',
    'identifiedOrgnrDelta3y',
    'identifiedOrgnrDelta5y',
    'companyBuzzCount',
    'companyBuzzIsRaisingCapital',
    'companyBuzzIsIpo',
    'companyBuzzIsMerger',
    'companyBuzzIsMoving',
    'companyBuzzIsHiring',
    'companyBuzzIsFiring',
    'companyBuzzIsClosing',
    'companyBuzzIsOpening',
    'companyBuzzIsExpanding',
    'companyBuzzIsDownsizing',
    'companyBuzzIsRestructuring',
    'companyBuzzIsNewProductIntro',
    'companyBuzzHasMoved',
    'companyBuzzIsChangingCeo',
    'companyBuzzIsChangingBoard',
    'companyBuzzIsChangingManagementTeam',
    'companyBuzzIsGrowthGeog',
    'companyBuzzIsGrowthSeg',
    'companyBuzzIsPricingModel',
    'companyBuzzIsPartnership',
    'companyBuzzIsMAndA',
    'companyBuzzIsDivest',
    'companyBuzzIsCostSave',
    'companyBuzzIsRestruct',
    'companyBuzzIsLayoff',
    'companyBuzzIsHirePlan',
    'companyBuzzIsLeadership',
    'companyBuzzIsCapexScale',
    'companyBuzzIsSupplyChain',
    'companyBuzzIsDigiAi',
    'companyBuzzIsEsgTarget',
    'companyBuzzIsEsgEvent',
    'companyBuzzIsRegChange',
    'companyBuzzIsLitigation',
    'companyBuzzIsFinRaise',
    'companyBuzzIsDivPolicy',
    'companyBuzzIsRevGuide',
    'companyBuzzIsRevMix',
    'companyBuzzIsCustMega',
    'companyBuzzIsRiskMacro',
    'mlLikelyToMoveProbability',
    'mlIsLikelyToMove',
    'moveInDateCurrentOffice',
    'moveDateOrLeaseExpirationDate',
    'moveDateOrLeaseExpirationDateIsWithinOneYear',
    'moveDateOrLeaseExpirationDateHasPassed',
    'isMoreThan5YearsSinceMoveInDateCurrentOffice',
    'workspaceSizeInM2',
    'workspaceSizeInM2PerEmployee',
    'nornormWebVisitorsLeadQuality',
    'nornormWebVisitorsNumberOfVisits',
    'nornormWebVisitorsCountryCode',
    'nornormWebVisitorsLastVisitDate',
    'nornormWebVisitorsFirstVisitDate',
    'activeJobpostsPerEmployee',
    '_6SensePhone',
    '_6SenseCity',
    '_6SenseDescription',
    '_6SenseCompanyType',
    '_6SenseIndustry',
    '_6SenseContinent',
    '_6SenceEmployeeRange',
    '_6SenseNaics',
    '_6SenseProductsOrServices',
    '_6SenseSic',
    '_6SenseStockExchange',
    '_6SenseStockSymbol',
    '_6SenseWebTechnologies',
    '_6SenseTotalFundingRange',
    '_6SenseYearFounded',
    'percentEmployeesWithMoreThan10YearsExperience',
    'hasOnSiteRequirements',
    'recentFunding',
    'nornormKeywordSearch',
    'nornormResearchedOffice',
    'nornormResearchedFurniture',
    'lookingForOffice',
    'isSittingOnCoWorkingSpace',
    'leaseExpirationDate',
    'leaseExpirationDateIsWithinOneYear',
    'nornormWebsiteVisitor',
    'numberOfAddresses',
    'apolloName',
    'apolloCountry',
    'apolloFoundedYear',
    'apolloPubliclyTradedSymbol',
    'apolloPubliclyTradedExchange',
    'apolloLatestFundingStage',
    'apolloLatestFundingRoundDate',
    'apolloTotalFunding',
    'apolloTotalFundingPrinted',
    'apolloEngineeringHeadCountCurrent',
    'apolloSalesHeadCountCurrent',
    'apolloSupportHeadCountCurrent',
    'apolloMarketingHeadCountCurrent',
    'apolloHumanResourcesHeadCountCurrent',
    'apolloEducationHeadCountCurrent',
    'apolloMediaAndCommunicationHeadCountCurrent',
    'apolloConsultingHeadCountCurrent',
    'apolloOperationsHeadCountCurrent',
    'apolloFinanceHeadCountCurrent',
    'apolloProductManagementHeadCountCurrent',
    'apolloBusinessDevelopmentHeadCountCurrent',
    'apolloInformationTechnologyHeadCountCurrent',
    'apolloDataScienceHeadCountCurrent',
    'apolloArtsAndDesignHeadCountCurrent',
    'apolloEntrepreneurshipHeadCountCurrent',
    'apolloAdministrativeHeadCountCurrent',
    'apolloLegalHeadCountCurrent',
    'apolloAccountingHeadCountCurrent',
    'apolloTotalHeadCountCurrent',
    'apolloEngineeringHeadCount1MonthAgo',
    'apolloSalesHeadCount1MonthAgo',
    'apolloSupportHeadCount1MonthAgo',
    'apolloMarketingHeadCount1MonthAgo',
    'apolloHumanResourcesHeadCount1MonthAgo',
    'apolloEducationHeadCount1MonthAgo',
    'apolloMediaAndCommunicationHeadCount1MonthAgo',
    'apolloConsultingHeadCount1MonthAgo',
    'apolloOperationsHeadCount1MonthAgo',
    'apolloFinanceHeadCount1MonthAgo',
    'apolloProductManagementHeadCount1MonthAgo',
    'apolloBusinessDevelopmentHeadCount1MonthAgo',
    'apolloInformationTechnologyHeadCount1MonthAgo',
    'apolloDataScienceHeadCount1MonthAgo',
    'apolloArtsAndDesignHeadCount1MonthAgo',
    'apolloEntrepreneurshipHeadCount1MonthAgo',
    'apolloAdministrativeHeadCount1MonthAgo',
    'apolloLegalHeadCount1MonthAgo',
    'apolloAccountingHeadCount1MonthAgo',
    'apolloTotalHeadCount1MonthAgo',
    'apolloEngineeringHeadCount3MonthsAgo',
    'apolloSalesHeadCount3MonthsAgo',
    'apolloSupportHeadCount3MonthsAgo',
    'apolloMarketingHeadCount3MonthsAgo',
    'apolloHumanResourcesHeadCount3MonthsAgo',
    'apolloEducationHeadCount3MonthsAgo',
    'apolloMediaAndCommunicationHeadCount3MonthsAgo',
    'apolloConsultingHeadCount3MonthsAgo',
    'apolloOperationsHeadCount3MonthsAgo',
    'apolloFinanceHeadCount3MonthsAgo',
    'apolloProductManagementHeadCount3MonthsAgo',
    'apolloBusinessDevelopmentHeadCount3MonthsAgo',
    'apolloInformationTechnologyHeadCount3MonthsAgo',
    'apolloDataScienceHeadCount3MonthsAgo',
    'apolloArtsAndDesignHeadCount3MonthsAgo',
    'apolloEntrepreneurshipHeadCount3MonthsAgo',
    'apolloAdministrativeHeadCount3MonthsAgo',
    'apolloLegalHeadCount3MonthsAgo',
    'apolloAccountingHeadCount3MonthsAgo',
    'apolloTotalHeadCount3MonthsAgo',
    'apolloEngineeringHeadCount6MonthsAgo',
    'apolloSalesHeadCount6MonthsAgo',
    'apolloSupportHeadCount6MonthsAgo',
    'apolloMarketingHeadCount6MonthsAgo',
    'apolloHumanResourcesHeadCount6MonthsAgo',
    'apolloEducationHeadCount6MonthsAgo',
    'apolloMediaAndCommunicationHeadCount6MonthsAgo',
    'apolloConsultingHeadCount6MonthsAgo',
    'apolloOperationsHeadCount6MonthsAgo',
    'apolloFinanceHeadCount6MonthsAgo',
    'apolloProductManagementHeadCount6MonthsAgo',
    'apolloBusinessDevelopmentHeadCount6MonthsAgo',
    'apolloInformationTechnologyHeadCount6MonthsAgo',
    'apolloDataScienceHeadCount6MonthsAgo',
    'apolloArtsAndDesignHeadCount6MonthsAgo',
    'apolloEntrepreneurshipHeadCount6MonthsAgo',
    'apolloAdministrativeHeadCount6MonthsAgo',
    'apolloLegalHeadCount6MonthsAgo',
    'apolloAccountingHeadCount6MonthsAgo',
    'apolloTotalHeadCount6MonthsAgo',
    'apolloEngineeringHeadCount9MonthsAgo',
    'apolloSalesHeadCount9MonthsAgo',
    'apolloSupportHeadCount9MonthsAgo',
    'apolloMarketingHeadCount9MonthsAgo',
    'apolloHumanResourcesHeadCount9MonthsAgo',
    'apolloEducationHeadCount9MonthsAgo',
    'apolloMediaAndCommunicationHeadCount9MonthsAgo',
    'apolloConsultingHeadCount9MonthsAgo',
    'apolloOperationsHeadCount9MonthsAgo',
    'apolloFinanceHeadCount9MonthsAgo',
    'apolloProductManagementHeadCount9MonthsAgo',
    'apolloBusinessDevelopmentHeadCount9MonthsAgo',
    'apolloInformationTechnologyHeadCount9MonthsAgo',
    'apolloDataScienceHeadCount9MonthsAgo',
    'apolloArtsAndDesignHeadCount9MonthsAgo',
    'apolloEntrepreneurshipHeadCount9MonthsAgo',
    'apolloAdministrativeHeadCount9MonthsAgo',
    'apolloLegalHeadCount9MonthsAgo',
    'apolloAccountingHeadCount9MonthsAgo',
    'apolloTotalHeadCount9MonthsAgo',
    'apolloEngineeringHeadCount12MonthsAgo',
    'apolloSalesHeadCount12MonthsAgo',
    'apolloSupportHeadCount12MonthsAgo',
    'apolloMarketingHeadCount12MonthsAgo',
    'apolloHumanResourcesHeadCount12MonthsAgo',
    'apolloEducationHeadCount12MonthsAgo',
    'apolloMediaAndCommunicationHeadCount12MonthsAgo',
    'apolloConsultingHeadCount12MonthsAgo',
    'apolloOperationsHeadCount12MonthsAgo',
    'apolloFinanceHeadCount12MonthsAgo',
    'apolloProductManagementHeadCount12MonthsAgo',
    'apolloBusinessDevelopmentHeadCount12MonthsAgo',
    'apolloInformationTechnologyHeadCount12MonthsAgo',
    'apolloDataScienceHeadCount12MonthsAgo',
    'apolloArtsAndDesignHeadCount12MonthsAgo',
    'apolloEntrepreneurshipHeadCount12MonthsAgo',
    'apolloAdministrativeHeadCount12MonthsAgo',
    'apolloLegalHeadCount12MonthsAgo',
    'apolloAccountingHeadCount12MonthsAgo',
    'apolloTotalHeadCount12MonthsAgo',
    'apolloEngineeringHeadCountGrowth1Month',
    'apolloSalesHeadCountGrowth1Month',
    'apolloSupportHeadCountGrowth1Month',
    'apolloMarketingHeadCountGrowth1Month',
    'apolloHumanResourcesHeadCountGrowth1Month',
    'apolloEducationHeadCountGrowth1Month',
    'apolloMediaAndCommunicationHeadCountGrowth1Month',
    'apolloConsultingHeadCountGrowth1Month',
    'apolloOperationsHeadCountGrowth1Month',
    'apolloFinanceHeadCountGrowth1Month',
    'apolloProductManagementHeadCountGrowth1Month',
    'apolloBusinessDevelopmentHeadCountGrowth1Month',
    'apolloInformationTechnologyHeadCountGrowth1Month',
    'apolloDataScienceHeadCountGrowth1Month',
    'apolloArtsAndDesignHeadCountGrowth1Month',
    'apolloEntrepreneurshipHeadCountGrowth1Month',
    'apolloAdministrativeHeadCountGrowth1Month',
    'apolloLegalHeadCountGrowth1Month',
    'apolloAccountingHeadCountGrowth1Month',
    'apolloTotalHeadCountGrowth1Month',
    'apolloEngineeringHeadCountGrowth3Months',
    'apolloSalesHeadCountGrowth3Months',
    'apolloSupportHeadCountGrowth3Months',
    'apolloMarketingHeadCountGrowth3Months',
    'apolloHumanResourcesHeadCountGrowth3Months',
    'apolloEducationHeadCountGrowth3Months',
    'apolloMediaAndCommunicationHeadCountGrowth3Months',
    'apolloConsultingHeadCountGrowth3Months',
    'apolloOperationsHeadCountGrowth3Months',
    'apolloFinanceHeadCountGrowth3Months',
    'apolloProductManagementHeadCountGrowth3Months',
    'apolloBusinessDevelopmentHeadCountGrowth3Months',
    'apolloInformationTechnologyHeadCountGrowth3Months',
    'apolloDataScienceHeadCountGrowth3Months',
    'apolloArtsAndDesignHeadCountGrowth3Months',
    'apolloEntrepreneurshipHeadCountGrowth3Months',
    'apolloAdministrativeHeadCountGrowth3Months',
    'apolloLegalHeadCountGrowth3Months',
    'apolloAccountingHeadCountGrowth3Months',
    'apolloTotalHeadCountGrowth3Months',
    'apolloEngineeringHeadCountGrowth6Months',
    'apolloSalesHeadCountGrowth6Months',
    'apolloSupportHeadCountGrowth6Months',
    'apolloMarketingHeadCountGrowth6Months',
    'apolloHumanResourcesHeadCountGrowth6Months',
    'apolloEducationHeadCountGrowth6Months',
    'apolloMediaAndCommunicationHeadCountGrowth6Months',
    'apolloConsultingHeadCountGrowth6Months',
    'apolloOperationsHeadCountGrowth6Months',
    'apolloFinanceHeadCountGrowth6Months',
    'apolloProductManagementHeadCountGrowth6Months',
    'apolloBusinessDevelopmentHeadCountGrowth6Months',
    'apolloInformationTechnologyHeadCountGrowth6Months',
    'apolloDataScienceHeadCountGrowth6Months',
    'apolloArtsAndDesignHeadCountGrowth6Months',
    'apolloEntrepreneurshipHeadCountGrowth6Months',
    'apolloAdministrativeHeadCountGrowth6Months',
    'apolloLegalHeadCountGrowth6Months',
    'apolloAccountingHeadCountGrowth6Months',
    'apolloTotalHeadCountGrowth6Months',
    'apolloEngineeringHeadCountGrowth9Months',
    'apolloSalesHeadCountGrowth9Months',
    'apolloSupportHeadCountGrowth9Months',
    'apolloMarketingHeadCountGrowth9Months',
    'apolloHumanResourcesHeadCountGrowth9Months',
    'apolloEducationHeadCountGrowth9Months',
    'apolloMediaAndCommunicationHeadCountGrowth9Months',
    'apolloConsultingHeadCountGrowth9Months',
    'apolloOperationsHeadCountGrowth9Months',
    'apolloFinanceHeadCountGrowth9Months',
    'apolloProductManagementHeadCountGrowth9Months',
    'apolloBusinessDevelopmentHeadCountGrowth9Months',
    'apolloInformationTechnologyHeadCountGrowth9Months',
    'apolloDataScienceHeadCountGrowth9Months',
    'apolloArtsAndDesignHeadCountGrowth9Months',
    'apolloEntrepreneurshipHeadCountGrowth9Months',
    'apolloAdministrativeHeadCountGrowth9Months',
    'apolloLegalHeadCountGrowth9Months',
    'apolloAccountingHeadCountGrowth9Months',
    'apolloTotalHeadCountGrowth9Months',
    'apolloEngineeringHeadCountGrowth12Months',
    'apolloSalesHeadCountGrowth12Months',
    'apolloSupportHeadCountGrowth12Months',
    'apolloMarketingHeadCountGrowth12Months',
    'apolloHumanResourcesHeadCountGrowth12Months',
    'apolloEducationHeadCountGrowth12Months',
    'apolloMediaAndCommunicationHeadCountGrowth12Months',
    'apolloConsultingHeadCountGrowth12Months',
    'apolloOperationsHeadCountGrowth12Months',
    'apolloFinanceHeadCountGrowth12Months',
    'apolloProductManagementHeadCountGrowth12Months',
    'apolloBusinessDevelopmentHeadCountGrowth12Months',
    'apolloInformationTechnologyHeadCountGrowth12Months',
    'apolloDataScienceHeadCountGrowth12Months',
    'apolloArtsAndDesignHeadCountGrowth12Months',
    'apolloEntrepreneurshipHeadCountGrowth12Months',
    'apolloAdministrativeHeadCountGrowth12Months',
    'apolloLegalHeadCountGrowth12Months',
    'apolloAccountingHeadCountGrowth12Months',
    'apolloTotalHeadCountGrowth12Months',
    'prvApplicantHasTrademark',
    'prvApplicantTrademarkCountTotal',
    'prvApplicantTrademarkCountActive',
    'prvApplicantTrademarksLast3mCount',
    'prvApplicantTrademarksLast12mCount',
    'prvApplicantAppliedLast3m',
    'prvApplicantAppliedLast12m',
    'prvApplicantLatestApplicationDate',
    'prvApplicantLatestStatus',
    'prvApplicantNiceClasses',
    'prvApplicantNiceClassCount',
    'prvApplicantTopMarks',
    'prvApplicantNextRenewalDate',
    'prvApplicantMappedCount',
    'prvApplicantMappingMethod',
    'prvApplicantLastMappedAt',
];
const masterDataRecordTest = true;
const masterDataDBRecordTest = true;
const mapToMasterDataRecord = (record) => ({
    iso3166: (0, function_1.pipe)(record.iso_3166, (0, utils_1.toType)('string')),
    orgnr: (0, function_1.pipe)(record.orgnr, (0, utils_1.toType)('string')),
    companyMasterSysPeriod: (0, function_1.pipe)(record.company_master_sys_period, (0, utils_1.toType)('tstzrange')),
    likelihoodToMoveScore: (0, function_1.pipe)(O.fromNullable(record.likelihood_to_move_score), O.map((0, utils_1.toType)('numeric'))),
    legalEntityType: (0, function_1.pipe)(O.fromNullable(record.legal_entity_type), O.map((0, utils_1.toType)('string'))),
    address: (0, function_1.pipe)(O.fromNullable(record.address), O.map((0, utils_1.toType)('string'))),
    zipcode: (0, function_1.pipe)(O.fromNullable(record.zipcode), O.map((0, utils_1.toType)('string'))),
    city: (0, function_1.pipe)(O.fromNullable(record.city), O.map((0, utils_1.toType)('string'))),
    muncipality: (0, function_1.pipe)(O.fromNullable(record.muncipality), O.map((0, utils_1.toType)('string'))),
    county: (0, function_1.pipe)(O.fromNullable(record.county), O.map((0, utils_1.toType)('string'))),
    region: (0, function_1.pipe)(O.fromNullable(record.region), O.map((0, utils_1.toType)('string'))),
    website: (0, function_1.pipe)(O.fromNullable(record.website), O.map((0, utils_1.toType)('string'))),
    phone: (0, function_1.pipe)(O.fromNullable(record.phone), O.map((0, utils_1.toType)('string'))),
    email: (0, function_1.pipe)(O.fromNullable(record.email), O.map((0, utils_1.toType)('string'))),
    registrationDate: (0, function_1.pipe)(O.fromNullable(record.registration_date), O.map((0, utils_1.toType)('date'))),
    companyCategory: (0, function_1.pipe)(O.fromNullable(record.company_category), O.map((0, utils_1.toType)('string'))),
    companyStructure: (0, function_1.pipe)(O.fromNullable(record.company_structure), O.map((0, utils_1.toType)('string'))),
    legalForm: (0, function_1.pipe)(O.fromNullable(record.legal_form), O.map((0, utils_1.toType)('string'))),
    listingType: (0, function_1.pipe)(O.fromNullable(record.listing_type), O.map((0, utils_1.toType)('string'))),
    descriptionEn: (0, function_1.pipe)(O.fromNullable(record.description_en), O.map((0, utils_1.toType)('string'))),
    operationalStatus: (0, function_1.pipe)(O.fromNullable(record.operational_status), O.map((0, utils_1.toType)('string'))),
    owners: (0, function_1.pipe)(O.fromNullable(record.owners), O.map((0, utils_1.toType)('string'))),
    keyPersons: (0, function_1.pipe)(O.fromNullable(record.key_persons), O.map((0, utils_1.toType)('string'))),
    signatory: (0, function_1.pipe)(O.fromNullable(record.signatory), O.map((0, utils_1.toType)('string'))),
    parentCompanyName: (0, function_1.pipe)(O.fromNullable(record.parent_company_name), O.map((0, utils_1.toType)('string'))),
    previousNames: (0, function_1.pipe)(O.fromNullable(record.previous_names), O.map((0, utils_1.toType)('string'))),
    accountantFirm: (0, function_1.pipe)(O.fromNullable(record.accountant_firm), O.map((0, utils_1.toType)('string'))),
    hasPrivateEquityOwner: (0, function_1.pipe)(O.fromNullable(record.has_private_equity_owner), O.map((0, utils_1.toType)('boolean'))),
    privateEquityOwner: (0, function_1.pipe)(O.fromNullable(record.private_equity_owner), O.map((0, utils_1.toType)('string'))),
    lfy: (0, function_1.pipe)(O.fromNullable(record.lfy), O.map((0, utils_1.toType)('date'))),
    lrq: (0, function_1.pipe)(O.fromNullable(record.lrq), O.map((0, utils_1.toType)('date'))),
    ceo: (0, function_1.pipe)(O.fromNullable(record.ceo), O.map((0, utils_1.toType)('string'))),
    ceoBirthYear: (0, function_1.pipe)(O.fromNullable(record.ceo_birth_year), O.map((0, utils_1.toType)('integer'))),
    chairman: (0, function_1.pipe)(O.fromNullable(record.chairman), O.map((0, utils_1.toType)('string'))),
    chairmanBirthYear: (0, function_1.pipe)(O.fromNullable(record.chairman_birth_year), O.map((0, utils_1.toType)('integer'))),
    hasShareIssues: (0, function_1.pipe)(O.fromNullable(record.has_share_issues), O.map((0, utils_1.toType)('boolean'))),
    numberOfOwners: (0, function_1.pipe)(O.fromNullable(record.number_of_owners), O.map((0, utils_1.toType)('integer'))),
    numberOfShares: (0, function_1.pipe)(O.fromNullable(record.number_of_shares), O.map((0, utils_1.toType)('numeric'))),
    hasForeignUltimateParent: (0, function_1.pipe)(O.fromNullable(record.has_foreign_ultimate_parent), O.map((0, utils_1.toType)('boolean'))),
    ultimateParentCompany: (0, function_1.pipe)(O.fromNullable(record.ultimate_parent_company), O.map((0, utils_1.toType)('string'))),
    ultimateParentOrgNo: (0, function_1.pipe)(O.fromNullable(record.ultimate_parent_org_no), O.map((0, utils_1.toType)('string'))),
    ultimateParentNetSales: (0, function_1.pipe)(O.fromNullable(record.ultimate_parent_net_sales), O.map((0, utils_1.toType)('numeric'))),
    companyName: (0, function_1.pipe)(O.fromNullable(record.company_name), O.map((0, utils_1.toType)('string'))),
    sniClassification: (0, function_1.pipe)(O.fromNullable(record.sni_classification), O.map((0, utils_1.toType)('string'))),
    sniClassificationCode: (0, function_1.pipe)(O.fromNullable(record.sni_classification_code), O.map((0, utils_1.toType)('string'))),
    financialsUpdatedDate: (0, function_1.pipe)(O.fromNullable(record.financials_updated_date), O.map((0, utils_1.toType)('date'))),
    lastUpdated: (0, function_1.pipe)(O.fromNullable(record.last_updated), O.map((0, utils_1.toType)('date'))),
    companyKeywords: (0, function_1.pipe)(O.fromNullable(record.company_keywords), O.map((0, utils_1.toType)('string-array'))),
    fiscalYear: (0, function_1.pipe)(O.fromNullable(record.fiscal_year), O.map((0, utils_1.toType)('integer'))),
    currency: (0, function_1.pipe)(O.fromNullable(record.currency), O.map((0, utils_1.toType)('string'))),
    netSales: (0, function_1.pipe)(O.fromNullable(record.net_sales), O.map((0, utils_1.toType)('numeric'))),
    costOfSales: (0, function_1.pipe)(O.fromNullable(record.cost_of_sales), O.map((0, utils_1.toType)('numeric'))),
    grossProfit: (0, function_1.pipe)(O.fromNullable(record.gross_profit), O.map((0, utils_1.toType)('numeric'))),
    administrativeExpenses: (0, function_1.pipe)(O.fromNullable(record.administrative_expenses), O.map((0, utils_1.toType)('numeric'))),
    sellingExpenses: (0, function_1.pipe)(O.fromNullable(record.selling_expenses), O.map((0, utils_1.toType)('numeric'))),
    otherExternalExpenses: (0, function_1.pipe)(O.fromNullable(record.other_external_expenses), O.map((0, utils_1.toType)('numeric'))),
    personelExpenses: (0, function_1.pipe)(O.fromNullable(record.personel_expenses), O.map((0, utils_1.toType)('numeric'))),
    ebit: (0, function_1.pipe)(O.fromNullable(record.ebit), O.map((0, utils_1.toType)('numeric'))),
    ebita: (0, function_1.pipe)(O.fromNullable(record.ebita), O.map((0, utils_1.toType)('numeric'))),
    ebitd: (0, function_1.pipe)(O.fromNullable(record.ebitd), O.map((0, utils_1.toType)('numeric'))),
    ebitda: (0, function_1.pipe)(O.fromNullable(record.ebitda), O.map((0, utils_1.toType)('numeric'))),
    deprAmo: (0, function_1.pipe)(O.fromNullable(record.depr_amo), O.map((0, utils_1.toType)('numeric'))),
    depreciation: (0, function_1.pipe)(O.fromNullable(record.depreciation), O.map((0, utils_1.toType)('numeric'))),
    amortisation: (0, function_1.pipe)(O.fromNullable(record.amortisation), O.map((0, utils_1.toType)('numeric'))),
    netFinancialIncomeOrExpenses: (0, function_1.pipe)(O.fromNullable(record.net_financial_income_or_expenses), O.map((0, utils_1.toType)('numeric'))),
    financialIncome: (0, function_1.pipe)(O.fromNullable(record.financial_income), O.map((0, utils_1.toType)('numeric'))),
    financialExpenses: (0, function_1.pipe)(O.fromNullable(record.financial_expenses), O.map((0, utils_1.toType)('numeric'))),
    preTaxProfit: (0, function_1.pipe)(O.fromNullable(record.pre_tax_profit), O.map((0, utils_1.toType)('numeric'))),
    netProfit: (0, function_1.pipe)(O.fromNullable(record.net_profit), O.map((0, utils_1.toType)('numeric'))),
    cashEquivalents: (0, function_1.pipe)(O.fromNullable(record.cash_equivalents), O.map((0, utils_1.toType)('numeric'))),
    accRec: (0, function_1.pipe)(O.fromNullable(record.acc_rec), O.map((0, utils_1.toType)('numeric'))),
    inventories: (0, function_1.pipe)(O.fromNullable(record.inventories), O.map((0, utils_1.toType)('numeric'))),
    othCurrOpAss: (0, function_1.pipe)(O.fromNullable(record.oth_curr_op_ass), O.map((0, utils_1.toType)('numeric'))),
    currFinAss: (0, function_1.pipe)(O.fromNullable(record.curr_fin_ass), O.map((0, utils_1.toType)('numeric'))),
    totalCurrentAssets: (0, function_1.pipe)(O.fromNullable(record.total_current_assets), O.map((0, utils_1.toType)('numeric'))),
    ppe: (0, function_1.pipe)(O.fromNullable(record.ppe), O.map((0, utils_1.toType)('numeric'))),
    goodwillIntangAss: (0, function_1.pipe)(O.fromNullable(record.goodwill_intang_ass), O.map((0, utils_1.toType)('numeric'))),
    nCurrFinRec: (0, function_1.pipe)(O.fromNullable(record.n_curr_fin_rec), O.map((0, utils_1.toType)('numeric'))),
    othNCurrOpAss: (0, function_1.pipe)(O.fromNullable(record.oth_n_curr_op_ass), O.map((0, utils_1.toType)('numeric'))),
    totalNonCurrentAssets: (0, function_1.pipe)(O.fromNullable(record.total_non_current_assets), O.map((0, utils_1.toType)('numeric'))),
    totalAssets: (0, function_1.pipe)(O.fromNullable(record.total_assets), O.map((0, utils_1.toType)('numeric'))),
    accPay: (0, function_1.pipe)(O.fromNullable(record.acc_pay), O.map((0, utils_1.toType)('numeric'))),
    currFinLiab: (0, function_1.pipe)(O.fromNullable(record.curr_fin_liab), O.map((0, utils_1.toType)('numeric'))),
    postEmplLiab: (0, function_1.pipe)(O.fromNullable(record.post_empl_liab), O.map((0, utils_1.toType)('numeric'))),
    othCurrOpLiab: (0, function_1.pipe)(O.fromNullable(record.oth_curr_op_liab), O.map((0, utils_1.toType)('numeric'))),
    totalCurrentLiabilities: (0, function_1.pipe)(O.fromNullable(record.total_current_liabilities), O.map((0, utils_1.toType)('numeric'))),
    othNCurrOpLiab: (0, function_1.pipe)(O.fromNullable(record.oth_n_curr_op_liab), O.map((0, utils_1.toType)('numeric'))),
    nCurrFinLiab: (0, function_1.pipe)(O.fromNullable(record.n_curr_fin_liab), O.map((0, utils_1.toType)('numeric'))),
    totalNonCurrLiab: (0, function_1.pipe)(O.fromNullable(record.total_non_curr_liab), O.map((0, utils_1.toType)('numeric'))),
    shareholdEq: (0, function_1.pipe)(O.fromNullable(record.sharehold_eq), O.map((0, utils_1.toType)('numeric'))),
    retainedEarnings: (0, function_1.pipe)(O.fromNullable(record.retained_earnings), O.map((0, utils_1.toType)('numeric'))),
    minInt: (0, function_1.pipe)(O.fromNullable(record.min_int), O.map((0, utils_1.toType)('numeric'))),
    totalEquity: (0, function_1.pipe)(O.fromNullable(record.total_equity), O.map((0, utils_1.toType)('numeric'))),
    dividends: (0, function_1.pipe)(O.fromNullable(record.dividends), O.map((0, utils_1.toType)('numeric'))),
    cashFlowBeforeFinAct: (0, function_1.pipe)(O.fromNullable(record.cash_flow_before_fin_act), O.map((0, utils_1.toType)('numeric'))),
    cashFlowOperating: (0, function_1.pipe)(O.fromNullable(record.cash_flow_operating), O.map((0, utils_1.toType)('numeric'))),
    ebitMargin: (0, function_1.pipe)(O.fromNullable(record.ebit_margin), O.map((0, utils_1.toType)('numeric'))),
    ebitdaMargin: (0, function_1.pipe)(O.fromNullable(record.ebitda_margin), O.map((0, utils_1.toType)('numeric'))),
    preTaxProfitMargin: (0, function_1.pipe)(O.fromNullable(record.pre_tax_profit_margin), O.map((0, utils_1.toType)('numeric'))),
    netProfitMargin: (0, function_1.pipe)(O.fromNullable(record.net_profit_margin), O.map((0, utils_1.toType)('numeric'))),
    roe: (0, function_1.pipe)(O.fromNullable(record.roe), O.map((0, utils_1.toType)('numeric'))),
    netCapex: (0, function_1.pipe)(O.fromNullable(record.net_capex), O.map((0, utils_1.toType)('numeric'))),
    netDebt: (0, function_1.pipe)(O.fromNullable(record.net_debt), O.map((0, utils_1.toType)('numeric'))),
    marketCap: (0, function_1.pipe)(O.fromNullable(record.market_cap), O.map((0, utils_1.toType)('numeric'))),
    annualReportNumberOfEmployees: (0, function_1.pipe)(O.fromNullable(record.annual_report_number_of_employees), O.map((0, utils_1.toType)('integer'))),
    fiscalYearLength: (0, function_1.pipe)(O.fromNullable(record.fiscal_year_length), O.map((0, utils_1.toType)('numeric'))),
    lfyMonth: (0, function_1.pipe)(O.fromNullable(record.lfy_month), O.map((0, utils_1.toType)('integer'))),
    netChangeInCash: (0, function_1.pipe)(O.fromNullable(record.net_change_in_cash), O.map((0, utils_1.toType)('numeric'))),
    netSalesGrowth: (0, function_1.pipe)(O.fromNullable(record.net_sales_growth), O.map((0, utils_1.toType)('numeric'))),
    cagr: (0, function_1.pipe)(O.fromNullable(record.cagr), O.map((0, utils_1.toType)('numeric'))),
    cagr3: (0, function_1.pipe)(O.fromNullable(record.cagr3), O.map((0, utils_1.toType)('numeric'))),
    ebitGrowth: (0, function_1.pipe)(O.fromNullable(record.ebit_growth), O.map((0, utils_1.toType)('numeric'))),
    cagr3ebit: (0, function_1.pipe)(O.fromNullable(record.cagr3ebit), O.map((0, utils_1.toType)('numeric'))),
    cagrebit: (0, function_1.pipe)(O.fromNullable(record.cagrebit), O.map((0, utils_1.toType)('numeric'))),
    ebitdaGrowth: (0, function_1.pipe)(O.fromNullable(record.ebitda_growth), O.map((0, utils_1.toType)('numeric'))),
    netProfitGrowth: (0, function_1.pipe)(O.fromNullable(record.net_profit_growth), O.map((0, utils_1.toType)('numeric'))),
    eps: (0, function_1.pipe)(O.fromNullable(record.eps), O.map((0, utils_1.toType)('numeric'))),
    equityRatio: (0, function_1.pipe)(O.fromNullable(record.equity_ratio), O.map((0, utils_1.toType)('numeric'))),
    netDebtToEbit: (0, function_1.pipe)(O.fromNullable(record.net_debt_to_ebit), O.map((0, utils_1.toType)('numeric'))),
    netDebtToEbitda: (0, function_1.pipe)(O.fromNullable(record.net_debt_to_ebitda), O.map((0, utils_1.toType)('numeric'))),
    netDebtToEquity: (0, function_1.pipe)(O.fromNullable(record.net_debt_to_equity), O.map((0, utils_1.toType)('numeric'))),
    evToEbit: (0, function_1.pipe)(O.fromNullable(record.ev_to_ebit), O.map((0, utils_1.toType)('numeric'))),
    evToEbitda: (0, function_1.pipe)(O.fromNullable(record.ev_to_ebitda), O.map((0, utils_1.toType)('numeric'))),
    evToNetSales: (0, function_1.pipe)(O.fromNullable(record.ev_to_net_sales), O.map((0, utils_1.toType)('numeric'))),
    pe: (0, function_1.pipe)(O.fromNullable(record.pe), O.map((0, utils_1.toType)('numeric'))),
    ev: (0, function_1.pipe)(O.fromNullable(record.ev), O.map((0, utils_1.toType)('numeric'))),
    pbv: (0, function_1.pipe)(O.fromNullable(record.pbv), O.map((0, utils_1.toType)('numeric'))),
    annualReportEmployeeGrowth: (0, function_1.pipe)(O.fromNullable(record.annual_report_employee_growth), O.map((0, utils_1.toType)('numeric'))),
    activeJobposts: (0, function_1.pipe)(O.fromNullable(record.active_jobposts), O.map((0, utils_1.toType)('integer'))),
    domainIsVerified: (0, function_1.pipe)(O.fromNullable(record.domain_is_verified), O.map((0, utils_1.toType)('boolean'))),
    domain: (0, function_1.pipe)(O.fromNullable(record.domain), O.map((0, utils_1.toType)('string'))),
    finalUrl: (0, function_1.pipe)(O.fromNullable(record.final_url), O.map((0, utils_1.toType)('string'))),
    error: (0, function_1.pipe)(O.fromNullable(record.error), O.map((0, utils_1.toType)('string'))),
    pageLoadTimeTti: (0, function_1.pipe)(O.fromNullable(record.page_load_time_tti), O.map((0, utils_1.toType)('integer'))),
    domainSysPeriod: (0, function_1.pipe)(O.fromNullable(record.domain_sys_period), O.map((0, utils_1.toType)('tstzrange'))),
    ipAddress: (0, function_1.pipe)(O.fromNullable(record.ip_address), O.map((0, utils_1.toType)('string'))),
    analyticsUa: (0, function_1.pipe)(O.fromNullable(record.analytics_ua), O.map((0, utils_1.toType)('integer'))),
    analyticsGa4: (0, function_1.pipe)(O.fromNullable(record.analytics_ga4), O.map((0, utils_1.toType)('integer'))),
    analyticsFb: (0, function_1.pipe)(O.fromNullable(record.analytics_fb), O.map((0, utils_1.toType)('integer'))),
    gconvpAccount: (0, function_1.pipe)(O.fromNullable(record.gconvp_account), O.map((0, utils_1.toType)('string'))),
    adobeAccount: (0, function_1.pipe)(O.fromNullable(record.adobe_account), O.map((0, utils_1.toType)('string'))),
    orgImage: (0, function_1.pipe)(O.fromNullable(record.org_image), O.map((0, utils_1.toType)('string'))),
    sitemaps: (0, function_1.pipe)(O.fromNullable(record.sitemaps), O.map((0, utils_1.toType)('string'))),
    cookieConsent: (0, function_1.pipe)(O.fromNullable(record.cookie_consent), O.map((0, utils_1.toType)('boolean'))),
    platform: (0, function_1.pipe)(O.fromNullable(record.platform), O.map((0, utils_1.toType)('string'))),
    server: (0, function_1.pipe)(O.fromNullable(record.server), O.map((0, utils_1.toType)('string'))),
    host: (0, function_1.pipe)(O.fromNullable(record.host), O.map((0, utils_1.toType)('string'))),
    domainKeywords: (0, function_1.pipe)(O.fromNullable(record.domain_keywords), O.map((0, utils_1.toType)('string'))),
    description: (0, function_1.pipe)(O.fromNullable(record.description), O.map((0, utils_1.toType)('string'))),
    descriptionWords: (0, function_1.pipe)(O.fromNullable(record.description_words), O.map((0, utils_1.toType)('integer'))),
    descriptionChars: (0, function_1.pipe)(O.fromNullable(record.description_chars), O.map((0, utils_1.toType)('integer'))),
    hostingProvider: (0, function_1.pipe)(O.fromNullable(record.hosting_provider), O.map((0, utils_1.toType)('string'))),
    hostingRegion: (0, function_1.pipe)(O.fromNullable(record.hosting_region), O.map((0, utils_1.toType)('string'))),
    isEcommerce: (0, function_1.pipe)(O.fromNullable(record.is_ecommerce), O.map((0, utils_1.toType)('boolean'))),
    ecommercePlatform: (0, function_1.pipe)(O.fromNullable(record.ecommerce_platform), O.map((0, utils_1.toType)('string-array'))),
    toolCookiebot: (0, function_1.pipe)(O.fromNullable(record.tool_cookiebot), O.map((0, utils_1.toType)('boolean'))),
    toolCookielaw: (0, function_1.pipe)(O.fromNullable(record.tool_cookielaw), O.map((0, utils_1.toType)('boolean'))),
    toolOnetrust: (0, function_1.pipe)(O.fromNullable(record.tool_onetrust), O.map((0, utils_1.toType)('boolean'))),
    toolDoubleclick: (0, function_1.pipe)(O.fromNullable(record.tool_doubleclick), O.map((0, utils_1.toType)('boolean'))),
    toolHotjar: (0, function_1.pipe)(O.fromNullable(record.tool_hotjar), O.map((0, utils_1.toType)('boolean'))),
    toolOptimizely: (0, function_1.pipe)(O.fromNullable(record.tool_optimizely), O.map((0, utils_1.toType)('boolean'))),
    toolEbbot: (0, function_1.pipe)(O.fromNullable(record.tool_ebbot), O.map((0, utils_1.toType)('boolean'))),
    toolIntercom: (0, function_1.pipe)(O.fromNullable(record.tool_intercom), O.map((0, utils_1.toType)('boolean'))),
    toolKlaviyo: (0, function_1.pipe)(O.fromNullable(record.tool_klaviyo), O.map((0, utils_1.toType)('boolean'))),
    toolHubspot: (0, function_1.pipe)(O.fromNullable(record.tool_hubspot), O.map((0, utils_1.toType)('boolean'))),
    toolMarketo: (0, function_1.pipe)(O.fromNullable(record.tool_marketo), O.map((0, utils_1.toType)('boolean'))),
    toolSalesforce: (0, function_1.pipe)(O.fromNullable(record.tool_salesforce), O.map((0, utils_1.toType)('boolean'))),
    toolTrustpilot: (0, function_1.pipe)(O.fromNullable(record.tool_trustpilot), O.map((0, utils_1.toType)('boolean'))),
    toolCustobar: (0, function_1.pipe)(O.fromNullable(record.tool_custobar), O.map((0, utils_1.toType)('boolean'))),
    toolVoyado: (0, function_1.pipe)(O.fromNullable(record.tool_voyado), O.map((0, utils_1.toType)('boolean'))),
    toolGodaddy: (0, function_1.pipe)(O.fromNullable(record.tool_godaddy), O.map((0, utils_1.toType)('boolean'))),
    toolShopify: (0, function_1.pipe)(O.fromNullable(record.tool_shopify), O.map((0, utils_1.toType)('boolean'))),
    toolSquarespace: (0, function_1.pipe)(O.fromNullable(record.tool_squarespace), O.map((0, utils_1.toType)('boolean'))),
    toolWix: (0, function_1.pipe)(O.fromNullable(record.tool_wix), O.map((0, utils_1.toType)('boolean'))),
    toolWordpress: (0, function_1.pipe)(O.fromNullable(record.tool_wordpress), O.map((0, utils_1.toType)('boolean'))),
    toolSeenthis: (0, function_1.pipe)(O.fromNullable(record.tool_seenthis), O.map((0, utils_1.toType)('boolean'))),
    toolYotpo: (0, function_1.pipe)(O.fromNullable(record.tool_yotpo), O.map((0, utils_1.toType)('boolean'))),
    toolApprl: (0, function_1.pipe)(O.fromNullable(record.tool_apprl), O.map((0, utils_1.toType)('boolean'))),
    toolCriteo: (0, function_1.pipe)(O.fromNullable(record.tool_criteo), O.map((0, utils_1.toType)('boolean'))),
    toolReco: (0, function_1.pipe)(O.fromNullable(record.tool_reco), O.map((0, utils_1.toType)('boolean'))),
    requestedHosts: (0, function_1.pipe)(O.fromNullable(record.requested_hosts), O.map((0, utils_1.toType)('string-array'))),
    analyticsGtm: (0, function_1.pipe)(O.fromNullable(record.analytics_gtm), O.map((0, utils_1.toType)('integer'))),
    analyticsAw: (0, function_1.pipe)(O.fromNullable(record.analytics_aw), O.map((0, utils_1.toType)('integer'))),
    toolGoogletagmanager: (0, function_1.pipe)(O.fromNullable(record.tool_googletagmanager), O.map((0, utils_1.toType)('boolean'))),
    sizeDocument: (0, function_1.pipe)(O.fromNullable(record.size_document), O.map((0, utils_1.toType)('integer'))),
    sizeScript: (0, function_1.pipe)(O.fromNullable(record.size_script), O.map((0, utils_1.toType)('integer'))),
    sizeStylesheet: (0, function_1.pipe)(O.fromNullable(record.size_stylesheet), O.map((0, utils_1.toType)('integer'))),
    sizeImage: (0, function_1.pipe)(O.fromNullable(record.size_image), O.map((0, utils_1.toType)('integer'))),
    sizeMedia: (0, function_1.pipe)(O.fromNullable(record.size_media), O.map((0, utils_1.toType)('integer'))),
    title: (0, function_1.pipe)(O.fromNullable(record.title), O.map((0, utils_1.toType)('string'))),
    titleWords: (0, function_1.pipe)(O.fromNullable(record.title_words), O.map((0, utils_1.toType)('integer'))),
    titleChars: (0, function_1.pipe)(O.fromNullable(record.title_chars), O.map((0, utils_1.toType)('integer'))),
    favicon: (0, function_1.pipe)(O.fromNullable(record.favicon), O.map((0, utils_1.toType)('string'))),
    canonical: (0, function_1.pipe)(O.fromNullable(record.canonical), O.map((0, utils_1.toType)('string'))),
    robots: (0, function_1.pipe)(O.fromNullable(record.robots), O.map((0, utils_1.toType)('string'))),
    noindex: (0, function_1.pipe)(O.fromNullable(record.noindex), O.map((0, utils_1.toType)('boolean'))),
    internalLinks: (0, function_1.pipe)(O.fromNullable(record.internal_links), O.map((0, utils_1.toType)('integer'))),
    externalLinks: (0, function_1.pipe)(O.fromNullable(record.external_links), O.map((0, utils_1.toType)('integer'))),
    analyticsMo: (0, function_1.pipe)(O.fromNullable(record.analytics_mo), O.map((0, utils_1.toType)('integer'))),
    lang: (0, function_1.pipe)(O.fromNullable(record.lang), O.map((0, utils_1.toType)('string'))),
    analyticsAdobe: (0, function_1.pipe)(O.fromNullable(record.analytics_adobe), O.map((0, utils_1.toType)('integer'))),
    colorsFont: (0, function_1.pipe)(O.fromNullable(record.colors_font), O.map((0, utils_1.toType)('string-array'))),
    colorsPage: (0, function_1.pipe)(O.fromNullable(record.colors_page), O.map((0, utils_1.toType)('string-array'))),
    colorsSvg: (0, function_1.pipe)(O.fromNullable(record.colors_svg), O.map((0, utils_1.toType)('string-array'))),
    accessViolationScore: (0, function_1.pipe)(O.fromNullable(record.access_violation_score), O.map((0, utils_1.toType)('numeric'))),
    violations: (0, function_1.pipe)(O.fromNullable(record.violations), O.map((0, utils_1.toType)('string-array'))),
    imgAltRatio: (0, function_1.pipe)(O.fromNullable(record.img_alt_ratio), O.map((0, utils_1.toType)('numeric'))),
    analyticsOpt: (0, function_1.pipe)(O.fromNullable(record.analytics_opt), O.map((0, utils_1.toType)('integer'))),
    analyticsAmplitude: (0, function_1.pipe)(O.fromNullable(record.analytics_amplitude), O.map((0, utils_1.toType)('integer'))),
    analyticsSnowplow: (0, function_1.pipe)(O.fromNullable(record.analytics_snowplow), O.map((0, utils_1.toType)('integer'))),
    trackersBeforeConsent: (0, function_1.pipe)(O.fromNullable(record.trackers_before_consent), O.map((0, utils_1.toType)('string-array'))),
    trackersBeforeConsentCount: (0, function_1.pipe)(O.fromNullable(record.trackers_before_consent_count), O.map((0, utils_1.toType)('integer'))),
    webVitalsTtfb: (0, function_1.pipe)(O.fromNullable(record.web_vitals_ttfb), O.map((0, utils_1.toType)('integer'))),
    webVitalsFcp: (0, function_1.pipe)(O.fromNullable(record.web_vitals_fcp), O.map((0, utils_1.toType)('integer'))),
    webVitalsLcp: (0, function_1.pipe)(O.fromNullable(record.web_vitals_lcp), O.map((0, utils_1.toType)('integer'))),
    webVitalsCls: (0, function_1.pipe)(O.fromNullable(record.web_vitals_cls), O.map((0, utils_1.toType)('integer'))),
    webVitalsTti: (0, function_1.pipe)(O.fromNullable(record.web_vitals_tti), O.map((0, utils_1.toType)('integer'))),
    webVitalsInp: (0, function_1.pipe)(O.fromNullable(record.web_vitals_inp), O.map((0, utils_1.toType)('integer'))),
    detectedLanguages: (0, function_1.pipe)(O.fromNullable(record.detected_languages), O.map((0, utils_1.toType)('string-array'))),
    languageCount: (0, function_1.pipe)(O.fromNullable(record.language_count), O.map((0, utils_1.toType)('integer'))),
    h1Content: (0, function_1.pipe)(O.fromNullable(record.h_1_content), O.map((0, utils_1.toType)('string-array'))),
    h1ContentWords: (0, function_1.pipe)(O.fromNullable(record.h_1_content_words), O.map((0, utils_1.toType)('numeric-array'))),
    h1ContentChars: (0, function_1.pipe)(O.fromNullable(record.h_1_content_chars), O.map((0, utils_1.toType)('numeric-array'))),
    h1Count: (0, function_1.pipe)(O.fromNullable(record.h_1_count), O.map((0, utils_1.toType)('integer'))),
    h2Count: (0, function_1.pipe)(O.fromNullable(record.h_2_count), O.map((0, utils_1.toType)('integer'))),
    h3Count: (0, function_1.pipe)(O.fromNullable(record.h_3_count), O.map((0, utils_1.toType)('integer'))),
    sitemap: (0, function_1.pipe)(O.fromNullable(record.sitemap), O.map((0, utils_1.toType)('string'))),
    sitemapCount: (0, function_1.pipe)(O.fromNullable(record.sitemap_count), O.map((0, utils_1.toType)('integer'))),
    sitemapUrlCount: (0, function_1.pipe)(O.fromNullable(record.sitemap_url_count), O.map((0, utils_1.toType)('integer'))),
    dnsA: (0, function_1.pipe)(O.fromNullable(record.dns_a), O.map((0, utils_1.toType)('string-array'))),
    dnsAaaa: (0, function_1.pipe)(O.fromNullable(record.dns_aaaa), O.map((0, utils_1.toType)('string-array'))),
    dnsNs: (0, function_1.pipe)(O.fromNullable(record.dns_ns), O.map((0, utils_1.toType)('string-array'))),
    dnsSoa: (0, function_1.pipe)(O.fromNullable(record.dns_soa), O.map((0, utils_1.toType)('string'))),
    dnsMx: (0, function_1.pipe)(O.fromNullable(record.dns_mx), O.map((0, utils_1.toType)('string'))),
    emailProvider: (0, function_1.pipe)(O.fromNullable(record.email_provider), O.map((0, utils_1.toType)('string'))),
    dnsSpf: (0, function_1.pipe)(O.fromNullable(record.dns_spf), O.map((0, utils_1.toType)('string-array'))),
    dnsDmarc: (0, function_1.pipe)(O.fromNullable(record.dns_dmarc), O.map((0, utils_1.toType)('boolean'))),
    dnsDmarcLevel: (0, function_1.pipe)(O.fromNullable(record.dns_dmarc_level), O.map((0, utils_1.toType)('string'))),
    dnsDmarcDetails: (0, function_1.pipe)(O.fromNullable(record.dns_dmarc_details), O.map((0, utils_1.toType)('string'))),
    dnsDkim: (0, function_1.pipe)(O.fromNullable(record.dns_dkim), O.map((0, utils_1.toType)('boolean'))),
    dnsDkimSelector: (0, function_1.pipe)(O.fromNullable(record.dns_dkim_selector), O.map((0, utils_1.toType)('string'))),
    dnsDkimLevel: (0, function_1.pipe)(O.fromNullable(record.dns_dkim_level), O.map((0, utils_1.toType)('string'))),
    dnsDkimDetails: (0, function_1.pipe)(O.fromNullable(record.dns_dkim_details), O.map((0, utils_1.toType)('string'))),
    dnsVerifications: (0, function_1.pipe)(O.fromNullable(record.dns_verifications), O.map((0, utils_1.toType)('string-array'))),
    sizeFont: (0, function_1.pipe)(O.fromNullable(record.size_font), O.map((0, utils_1.toType)('integer'))),
    sizeXhr: (0, function_1.pipe)(O.fromNullable(record.size_xhr), O.map((0, utils_1.toType)('integer'))),
    sizePing: (0, function_1.pipe)(O.fromNullable(record.size_ping), O.map((0, utils_1.toType)('integer'))),
    sizeFetch: (0, function_1.pipe)(O.fromNullable(record.size_fetch), O.map((0, utils_1.toType)('integer'))),
    sizeOther: (0, function_1.pipe)(O.fromNullable(record.size_other), O.map((0, utils_1.toType)('integer'))),
    xRobotsTag: (0, function_1.pipe)(O.fromNullable(record.x_robots_tag), O.map((0, utils_1.toType)('string'))),
    framework: (0, function_1.pipe)(O.fromNullable(record.framework), O.map((0, utils_1.toType)('string'))),
    cookies: (0, function_1.pipe)(O.fromNullable(record.cookies), O.map((0, utils_1.toType)('string'))),
    hasSchemaScript: (0, function_1.pipe)(O.fromNullable(record.has_schema_script), O.map((0, utils_1.toType)('boolean'))),
    imgCount: (0, function_1.pipe)(O.fromNullable(record.img_count), O.map((0, utils_1.toType)('integer'))),
    imgAltCount: (0, function_1.pipe)(O.fromNullable(record.img_alt_count), O.map((0, utils_1.toType)('integer'))),
    imgMissingAltCount: (0, function_1.pipe)(O.fromNullable(record.img_missing_alt_count), O.map((0, utils_1.toType)('integer'))),
    imgTitleCount: (0, function_1.pipe)(O.fromNullable(record.img_title_count), O.map((0, utils_1.toType)('integer'))),
    snapchatHandle: (0, function_1.pipe)(O.fromNullable(record.snapchat_handle), O.map((0, utils_1.toType)('string-array'))),
    linkedinIsVerified: (0, function_1.pipe)(O.fromNullable(record.linkedin_is_verified), O.map((0, utils_1.toType)('boolean'))),
    linkedinId: (0, function_1.pipe)(O.fromNullable(record.linkedin_id), O.map((0, utils_1.toType)('string'))),
    linkedinDomain: (0, function_1.pipe)(O.fromNullable(record.linkedin_domain), O.map((0, utils_1.toType)('string'))),
    linkedinIndustry: (0, function_1.pipe)(O.fromNullable(record.linkedin_industry), O.map((0, utils_1.toType)('string'))),
    linkedinNumberOfEmployees: (0, function_1.pipe)(O.fromNullable(record.linkedin_number_of_employees), O.map((0, utils_1.toType)('integer'))),
    linkedinAllEmployeeGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.linkedin_all_employee_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    linkedinAllEmployeeGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.linkedin_all_employee_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    linkedinAllEmployeeGrowth1Year: (0, function_1.pipe)(O.fromNullable(record.linkedin_all_employee_growth_1_year), O.map((0, utils_1.toType)('numeric'))),
    linkedinAllEmployeeGrowth2Years: (0, function_1.pipe)(O.fromNullable(record.linkedin_all_employee_growth_2_years), O.map((0, utils_1.toType)('numeric'))),
    numberOfEmployees: (0, function_1.pipe)(O.fromNullable(record.number_of_employees), O.map((0, utils_1.toType)('integer'))),
    numberOfEmployeesSource: (0, function_1.pipe)(O.fromNullable(record.number_of_employees_source), O.map((0, utils_1.toType)('string'))),
    identifiedOrgnrCount: (0, function_1.pipe)(O.fromNullable(record.identified_orgnr_count), O.map((0, utils_1.toType)('integer'))),
    identifiedOrgnrDelta6m: (0, function_1.pipe)(O.fromNullable(record.identified_orgnr_delta_6m), O.map((0, utils_1.toType)('integer'))),
    identifiedOrgnrDelta1y: (0, function_1.pipe)(O.fromNullable(record.identified_orgnr_delta_1y), O.map((0, utils_1.toType)('integer'))),
    identifiedOrgnrDelta3y: (0, function_1.pipe)(O.fromNullable(record.identified_orgnr_delta_3y), O.map((0, utils_1.toType)('integer'))),
    identifiedOrgnrDelta5y: (0, function_1.pipe)(O.fromNullable(record.identified_orgnr_delta_5y), O.map((0, utils_1.toType)('integer'))),
    companyBuzzCount: (0, function_1.pipe)(record.company_buzz_count, (0, utils_1.toType)('integer')),
    companyBuzzIsRaisingCapital: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_raising_capital), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsIpo: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_ipo), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsMerger: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_merger), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsMoving: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_moving), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsHiring: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_hiring), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsFiring: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_firing), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsClosing: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_closing), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsOpening: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_opening), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsExpanding: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_expanding), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsDownsizing: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_downsizing), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRestructuring: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_restructuring), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsNewProductIntro: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_new_product_intro), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzHasMoved: (0, function_1.pipe)(O.fromNullable(record.company_buzz_has_moved), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsChangingCeo: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_changing_ceo), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsChangingBoard: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_changing_board), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsChangingManagementTeam: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_changing_management_team), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsGrowthGeog: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_growth_geog), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsGrowthSeg: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_growth_seg), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsPricingModel: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_pricing_model), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsPartnership: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_partnership), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsMAndA: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_m_and_a), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsDivest: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_divest), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsCostSave: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_cost_save), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRestruct: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_restruct), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsLayoff: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_layoff), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsHirePlan: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_hire_plan), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsLeadership: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_leadership), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsCapexScale: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_capex_scale), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsSupplyChain: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_supply_chain), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsDigiAi: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_digi_ai), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsEsgTarget: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_esg_target), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsEsgEvent: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_esg_event), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRegChange: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_reg_change), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsLitigation: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_litigation), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsFinRaise: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_fin_raise), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsDivPolicy: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_div_policy), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRevGuide: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_rev_guide), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRevMix: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_rev_mix), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsCustMega: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_cust_mega), O.map((0, utils_1.toType)('boolean'))),
    companyBuzzIsRiskMacro: (0, function_1.pipe)(O.fromNullable(record.company_buzz_is_risk_macro), O.map((0, utils_1.toType)('boolean'))),
    mlLikelyToMoveProbability: (0, function_1.pipe)(O.fromNullable(record.ml_likely_to_move_probability), O.map((0, utils_1.toType)('numeric'))),
    mlIsLikelyToMove: (0, function_1.pipe)(O.fromNullable(record.ml_is_likely_to_move), O.map((0, utils_1.toType)('boolean'))),
    moveInDateCurrentOffice: (0, function_1.pipe)(O.fromNullable(record.move_in_date_current_office), O.map((0, utils_1.toType)('date'))),
    moveDateOrLeaseExpirationDate: (0, function_1.pipe)(O.fromNullable(record.move_date_or_lease_expiration_date), O.map((0, utils_1.toType)('date'))),
    moveDateOrLeaseExpirationDateIsWithinOneYear: (0, function_1.pipe)(O.fromNullable(record.move_date_or_lease_expiration_date_is_within_one_year), O.map((0, utils_1.toType)('boolean'))),
    moveDateOrLeaseExpirationDateHasPassed: (0, function_1.pipe)(O.fromNullable(record.move_date_or_lease_expiration_date_has_passed), O.map((0, utils_1.toType)('boolean'))),
    isMoreThan5YearsSinceMoveInDateCurrentOffice: (0, function_1.pipe)(O.fromNullable(record.is_more_than_5_years_since_move_in_date_current_office), O.map((0, utils_1.toType)('boolean'))),
    workspaceSizeInM2: (0, function_1.pipe)(O.fromNullable(record.workspace_size_in_m2), O.map((0, utils_1.toType)('integer'))),
    workspaceSizeInM2PerEmployee: (0, function_1.pipe)(O.fromNullable(record.workspace_size_in_m2_per_employee), O.map((0, utils_1.toType)('numeric'))),
    nornormWebVisitorsLeadQuality: (0, function_1.pipe)(O.fromNullable(record.nornorm_web_visitors_lead_quality), O.map((0, utils_1.toType)('numeric'))),
    nornormWebVisitorsNumberOfVisits: (0, function_1.pipe)(O.fromNullable(record.nornorm_web_visitors_number_of_visits), O.map((0, utils_1.toType)('integer'))),
    nornormWebVisitorsCountryCode: (0, function_1.pipe)(O.fromNullable(record.nornorm_web_visitors_country_code), O.map((0, utils_1.toType)('string'))),
    nornormWebVisitorsLastVisitDate: (0, function_1.pipe)(O.fromNullable(record.nornorm_web_visitors_last_visit_date), O.map((0, utils_1.toType)('date'))),
    nornormWebVisitorsFirstVisitDate: (0, function_1.pipe)(O.fromNullable(record.nornorm_web_visitors_first_visit_date), O.map((0, utils_1.toType)('date'))),
    activeJobpostsPerEmployee: (0, function_1.pipe)(O.fromNullable(record.active_jobposts_per_employee), O.map((0, utils_1.toType)('numeric'))),
    _6SensePhone: (0, function_1.pipe)(O.fromNullable(record._6_sense_phone), O.map((0, utils_1.toType)('string'))),
    _6SenseCity: (0, function_1.pipe)(O.fromNullable(record._6_sense_city), O.map((0, utils_1.toType)('string'))),
    _6SenseDescription: (0, function_1.pipe)(O.fromNullable(record._6_sense_description), O.map((0, utils_1.toType)('string'))),
    _6SenseCompanyType: (0, function_1.pipe)(O.fromNullable(record._6_sense_company_type), O.map((0, utils_1.toType)('string'))),
    _6SenseIndustry: (0, function_1.pipe)(O.fromNullable(record._6_sense_industry), O.map((0, utils_1.toType)('string'))),
    _6SenseContinent: (0, function_1.pipe)(O.fromNullable(record._6_sense_continent), O.map((0, utils_1.toType)('string'))),
    _6SenceEmployeeRange: (0, function_1.pipe)(O.fromNullable(record._6_sence_employee_range), O.map((0, utils_1.toType)('numeric-array'))),
    _6SenseNaics: (0, function_1.pipe)(O.fromNullable(record._6_sense_naics), O.map((0, utils_1.toType)('string'))),
    _6SenseProductsOrServices: (0, function_1.pipe)(O.fromNullable(record._6_sense_products_or_services), O.map((0, utils_1.toType)('string-array'))),
    _6SenseSic: (0, function_1.pipe)(O.fromNullable(record._6_sense_sic), O.map((0, utils_1.toType)('string'))),
    _6SenseStockExchange: (0, function_1.pipe)(O.fromNullable(record._6_sense_stock_exchange), O.map((0, utils_1.toType)('string'))),
    _6SenseStockSymbol: (0, function_1.pipe)(O.fromNullable(record._6_sense_stock_symbol), O.map((0, utils_1.toType)('string'))),
    _6SenseWebTechnologies: (0, function_1.pipe)(O.fromNullable(record._6_sense_web_technologies), O.map((0, utils_1.toType)('string-array'))),
    _6SenseTotalFundingRange: (0, function_1.pipe)(O.fromNullable(record._6_sense_total_funding_range), O.map((0, utils_1.toType)('string'))),
    _6SenseYearFounded: (0, function_1.pipe)(O.fromNullable(record._6_sense_year_founded), O.map((0, utils_1.toType)('integer'))),
    percentEmployeesWithMoreThan10YearsExperience: (0, function_1.pipe)(O.fromNullable(record.percent_employees_with_more_than_10_years_experience), O.map((0, utils_1.toType)('numeric'))),
    hasOnSiteRequirements: (0, function_1.pipe)(O.fromNullable(record.has_on_site_requirements), O.map((0, utils_1.toType)('boolean'))),
    recentFunding: (0, function_1.pipe)(O.fromNullable(record.recent_funding), O.map((0, utils_1.toType)('boolean'))),
    nornormKeywordSearch: (0, function_1.pipe)(O.fromNullable(record.nornorm_keyword_search), O.map((0, utils_1.toType)('boolean'))),
    nornormResearchedOffice: (0, function_1.pipe)(O.fromNullable(record.nornorm_researched_office), O.map((0, utils_1.toType)('boolean'))),
    nornormResearchedFurniture: (0, function_1.pipe)(O.fromNullable(record.nornorm_researched_furniture), O.map((0, utils_1.toType)('boolean'))),
    lookingForOffice: (0, function_1.pipe)(O.fromNullable(record.looking_for_office), O.map((0, utils_1.toType)('boolean'))),
    isSittingOnCoWorkingSpace: (0, function_1.pipe)(O.fromNullable(record.is_sitting_on_co_working_space), O.map((0, utils_1.toType)('boolean'))),
    leaseExpirationDate: (0, function_1.pipe)(O.fromNullable(record.lease_expiration_date), O.map((0, utils_1.toType)('date'))),
    leaseExpirationDateIsWithinOneYear: (0, function_1.pipe)(O.fromNullable(record.lease_expiration_date_is_within_one_year), O.map((0, utils_1.toType)('boolean'))),
    nornormWebsiteVisitor: (0, function_1.pipe)(O.fromNullable(record.nornorm_website_visitor), O.map((0, utils_1.toType)('boolean'))),
    numberOfAddresses: (0, function_1.pipe)(O.fromNullable(record.number_of_addresses), O.map((0, utils_1.toType)('integer'))),
    apolloName: (0, function_1.pipe)(O.fromNullable(record.apollo_name), O.map((0, utils_1.toType)('string'))),
    apolloCountry: (0, function_1.pipe)(O.fromNullable(record.apollo_country), O.map((0, utils_1.toType)('string'))),
    apolloFoundedYear: (0, function_1.pipe)(O.fromNullable(record.apollo_founded_year), O.map((0, utils_1.toType)('integer'))),
    apolloPubliclyTradedSymbol: (0, function_1.pipe)(O.fromNullable(record.apollo_publicly_traded_symbol), O.map((0, utils_1.toType)('string'))),
    apolloPubliclyTradedExchange: (0, function_1.pipe)(O.fromNullable(record.apollo_publicly_traded_exchange), O.map((0, utils_1.toType)('string'))),
    apolloLatestFundingStage: (0, function_1.pipe)(O.fromNullable(record.apollo_latest_funding_stage), O.map((0, utils_1.toType)('string'))),
    apolloLatestFundingRoundDate: (0, function_1.pipe)(O.fromNullable(record.apollo_latest_funding_round_date), O.map((0, utils_1.toType)('date'))),
    apolloTotalFunding: (0, function_1.pipe)(O.fromNullable(record.apollo_total_funding), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalFundingPrinted: (0, function_1.pipe)(O.fromNullable(record.apollo_total_funding_printed), O.map((0, utils_1.toType)('string'))),
    apolloEngineeringHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCountCurrent: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_current), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCount1MonthAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_1_month_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCount3MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_3_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCount6MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_6_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCount9MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_9_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSalesHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloSupportHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMarketingHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloHumanResourcesHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEducationHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloMediaAndCommunicationHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloConsultingHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloOperationsHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloFinanceHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloProductManagementHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloBusinessDevelopmentHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloInformationTechnologyHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloDataScienceHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloArtsAndDesignHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEntrepreneurshipHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAdministrativeHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloLegalHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloAccountingHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloTotalHeadCount12MonthsAgo: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_12_months_ago), O.map((0, utils_1.toType)('integer'))),
    apolloEngineeringHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloSalesHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloSupportHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloMarketingHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloHumanResourcesHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloEducationHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloMediaAndCommunicationHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloConsultingHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloOperationsHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloFinanceHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloProductManagementHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloBusinessDevelopmentHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloInformationTechnologyHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloDataScienceHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloArtsAndDesignHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloEntrepreneurshipHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloAdministrativeHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloLegalHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloAccountingHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalHeadCountGrowth1Month: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_growth_1_month), O.map((0, utils_1.toType)('numeric'))),
    apolloEngineeringHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSalesHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSupportHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMarketingHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloHumanResourcesHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEducationHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMediaAndCommunicationHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloConsultingHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloOperationsHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloFinanceHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloProductManagementHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloBusinessDevelopmentHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloInformationTechnologyHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloDataScienceHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloArtsAndDesignHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEntrepreneurshipHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAdministrativeHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloLegalHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAccountingHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalHeadCountGrowth3Months: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_growth_3_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEngineeringHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSalesHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSupportHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMarketingHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloHumanResourcesHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEducationHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMediaAndCommunicationHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloConsultingHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloOperationsHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloFinanceHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloProductManagementHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloBusinessDevelopmentHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloInformationTechnologyHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloDataScienceHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloArtsAndDesignHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEntrepreneurshipHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAdministrativeHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloLegalHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAccountingHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalHeadCountGrowth6Months: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_growth_6_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEngineeringHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSalesHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSupportHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMarketingHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloHumanResourcesHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEducationHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMediaAndCommunicationHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloConsultingHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloOperationsHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloFinanceHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloProductManagementHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloBusinessDevelopmentHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloInformationTechnologyHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloDataScienceHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloArtsAndDesignHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEntrepreneurshipHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAdministrativeHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloLegalHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAccountingHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalHeadCountGrowth9Months: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_growth_9_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEngineeringHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_engineering_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSalesHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_sales_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloSupportHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_support_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMarketingHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_marketing_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloHumanResourcesHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_human_resources_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEducationHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_education_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloMediaAndCommunicationHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_media_and_communication_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloConsultingHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_consulting_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloOperationsHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_operations_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloFinanceHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_finance_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloProductManagementHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_product_management_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloBusinessDevelopmentHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_business_development_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloInformationTechnologyHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_information_technology_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloDataScienceHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_data_science_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloArtsAndDesignHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_arts_and_design_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloEntrepreneurshipHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_entrepreneurship_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAdministrativeHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_administrative_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloLegalHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_legal_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloAccountingHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_accounting_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    apolloTotalHeadCountGrowth12Months: (0, function_1.pipe)(O.fromNullable(record.apollo_total_head_count_growth_12_months), O.map((0, utils_1.toType)('numeric'))),
    prvApplicantHasTrademark: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_has_trademark), O.map((0, utils_1.toType)('boolean'))),
    prvApplicantTrademarkCountTotal: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_trademark_count_total), O.map((0, utils_1.toType)('integer'))),
    prvApplicantTrademarkCountActive: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_trademark_count_active), O.map((0, utils_1.toType)('integer'))),
    prvApplicantTrademarksLast3mCount: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_trademarks_last_3m_count), O.map((0, utils_1.toType)('integer'))),
    prvApplicantTrademarksLast12mCount: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_trademarks_last_12m_count), O.map((0, utils_1.toType)('integer'))),
    prvApplicantAppliedLast3m: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_applied_last_3m), O.map((0, utils_1.toType)('boolean'))),
    prvApplicantAppliedLast12m: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_applied_last_12m), O.map((0, utils_1.toType)('boolean'))),
    prvApplicantLatestApplicationDate: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_latest_application_date), O.map((0, utils_1.toType)('date'))),
    prvApplicantLatestStatus: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_latest_status), O.map((0, utils_1.toType)('string'))),
    prvApplicantNiceClasses: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_nice_classes), O.map((0, utils_1.toType)('numeric-array'))),
    prvApplicantNiceClassCount: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_nice_class_count), O.map((0, utils_1.toType)('integer'))),
    prvApplicantTopMarks: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_top_marks), O.map((0, utils_1.toType)('string-array'))),
    prvApplicantNextRenewalDate: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_next_renewal_date), O.map((0, utils_1.toType)('date'))),
    prvApplicantMappedCount: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_mapped_count), O.map((0, utils_1.toType)('integer'))),
    prvApplicantMappingMethod: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_mapping_method), O.map((0, utils_1.toType)('string'))),
    prvApplicantLastMappedAt: (0, function_1.pipe)(O.fromNullable(record.prv_applicant_last_mapped_at), O.map((0, utils_1.toType)('date'))),
});
exports.mapToMasterDataRecord = mapToMasterDataRecord;
const mapToMasterDataDBRecord = (record) => ({
    iso_3166: record.iso3166,
    orgnr: record.orgnr,
    company_master_sys_period: record.companyMasterSysPeriod,
    likelihood_to_move_score: O.toNullable(record.likelihoodToMoveScore),
    legal_entity_type: O.toNullable(record.legalEntityType),
    address: O.toNullable(record.address),
    zipcode: O.toNullable(record.zipcode),
    city: O.toNullable(record.city),
    muncipality: O.toNullable(record.muncipality),
    county: O.toNullable(record.county),
    region: O.toNullable(record.region),
    website: O.toNullable(record.website),
    phone: O.toNullable(record.phone),
    email: O.toNullable(record.email),
    registration_date: O.toNullable(record.registrationDate),
    company_category: O.toNullable(record.companyCategory),
    company_structure: O.toNullable(record.companyStructure),
    legal_form: O.toNullable(record.legalForm),
    listing_type: O.toNullable(record.listingType),
    description_en: O.toNullable(record.descriptionEn),
    operational_status: O.toNullable(record.operationalStatus),
    owners: O.toNullable(record.owners),
    key_persons: O.toNullable(record.keyPersons),
    signatory: O.toNullable(record.signatory),
    parent_company_name: O.toNullable(record.parentCompanyName),
    previous_names: O.toNullable(record.previousNames),
    accountant_firm: O.toNullable(record.accountantFirm),
    has_private_equity_owner: O.toNullable(record.hasPrivateEquityOwner),
    private_equity_owner: O.toNullable(record.privateEquityOwner),
    lfy: O.toNullable(record.lfy),
    lrq: O.toNullable(record.lrq),
    ceo: O.toNullable(record.ceo),
    ceo_birth_year: O.toNullable(record.ceoBirthYear),
    chairman: O.toNullable(record.chairman),
    chairman_birth_year: O.toNullable(record.chairmanBirthYear),
    has_share_issues: O.toNullable(record.hasShareIssues),
    number_of_owners: O.toNullable(record.numberOfOwners),
    number_of_shares: O.toNullable(record.numberOfShares),
    has_foreign_ultimate_parent: O.toNullable(record.hasForeignUltimateParent),
    ultimate_parent_company: O.toNullable(record.ultimateParentCompany),
    ultimate_parent_org_no: O.toNullable(record.ultimateParentOrgNo),
    ultimate_parent_net_sales: O.toNullable(record.ultimateParentNetSales),
    company_name: O.toNullable(record.companyName),
    sni_classification: O.toNullable(record.sniClassification),
    sni_classification_code: O.toNullable(record.sniClassificationCode),
    financials_updated_date: O.toNullable(record.financialsUpdatedDate),
    last_updated: O.toNullable(record.lastUpdated),
    company_keywords: O.toNullable(record.companyKeywords),
    fiscal_year: O.toNullable(record.fiscalYear),
    currency: O.toNullable(record.currency),
    net_sales: O.toNullable(record.netSales),
    cost_of_sales: O.toNullable(record.costOfSales),
    gross_profit: O.toNullable(record.grossProfit),
    administrative_expenses: O.toNullable(record.administrativeExpenses),
    selling_expenses: O.toNullable(record.sellingExpenses),
    other_external_expenses: O.toNullable(record.otherExternalExpenses),
    personel_expenses: O.toNullable(record.personelExpenses),
    ebit: O.toNullable(record.ebit),
    ebita: O.toNullable(record.ebita),
    ebitd: O.toNullable(record.ebitd),
    ebitda: O.toNullable(record.ebitda),
    depr_amo: O.toNullable(record.deprAmo),
    depreciation: O.toNullable(record.depreciation),
    amortisation: O.toNullable(record.amortisation),
    net_financial_income_or_expenses: O.toNullable(record.netFinancialIncomeOrExpenses),
    financial_income: O.toNullable(record.financialIncome),
    financial_expenses: O.toNullable(record.financialExpenses),
    pre_tax_profit: O.toNullable(record.preTaxProfit),
    net_profit: O.toNullable(record.netProfit),
    cash_equivalents: O.toNullable(record.cashEquivalents),
    acc_rec: O.toNullable(record.accRec),
    inventories: O.toNullable(record.inventories),
    oth_curr_op_ass: O.toNullable(record.othCurrOpAss),
    curr_fin_ass: O.toNullable(record.currFinAss),
    total_current_assets: O.toNullable(record.totalCurrentAssets),
    ppe: O.toNullable(record.ppe),
    goodwill_intang_ass: O.toNullable(record.goodwillIntangAss),
    n_curr_fin_rec: O.toNullable(record.nCurrFinRec),
    oth_n_curr_op_ass: O.toNullable(record.othNCurrOpAss),
    total_non_current_assets: O.toNullable(record.totalNonCurrentAssets),
    total_assets: O.toNullable(record.totalAssets),
    acc_pay: O.toNullable(record.accPay),
    curr_fin_liab: O.toNullable(record.currFinLiab),
    post_empl_liab: O.toNullable(record.postEmplLiab),
    oth_curr_op_liab: O.toNullable(record.othCurrOpLiab),
    total_current_liabilities: O.toNullable(record.totalCurrentLiabilities),
    oth_n_curr_op_liab: O.toNullable(record.othNCurrOpLiab),
    n_curr_fin_liab: O.toNullable(record.nCurrFinLiab),
    total_non_curr_liab: O.toNullable(record.totalNonCurrLiab),
    sharehold_eq: O.toNullable(record.shareholdEq),
    retained_earnings: O.toNullable(record.retainedEarnings),
    min_int: O.toNullable(record.minInt),
    total_equity: O.toNullable(record.totalEquity),
    dividends: O.toNullable(record.dividends),
    cash_flow_before_fin_act: O.toNullable(record.cashFlowBeforeFinAct),
    cash_flow_operating: O.toNullable(record.cashFlowOperating),
    ebit_margin: O.toNullable(record.ebitMargin),
    ebitda_margin: O.toNullable(record.ebitdaMargin),
    pre_tax_profit_margin: O.toNullable(record.preTaxProfitMargin),
    net_profit_margin: O.toNullable(record.netProfitMargin),
    roe: O.toNullable(record.roe),
    net_capex: O.toNullable(record.netCapex),
    net_debt: O.toNullable(record.netDebt),
    market_cap: O.toNullable(record.marketCap),
    annual_report_number_of_employees: O.toNullable(record.annualReportNumberOfEmployees),
    fiscal_year_length: O.toNullable(record.fiscalYearLength),
    lfy_month: O.toNullable(record.lfyMonth),
    net_change_in_cash: O.toNullable(record.netChangeInCash),
    net_sales_growth: O.toNullable(record.netSalesGrowth),
    cagr: O.toNullable(record.cagr),
    cagr3: O.toNullable(record.cagr3),
    ebit_growth: O.toNullable(record.ebitGrowth),
    cagr3ebit: O.toNullable(record.cagr3ebit),
    cagrebit: O.toNullable(record.cagrebit),
    ebitda_growth: O.toNullable(record.ebitdaGrowth),
    net_profit_growth: O.toNullable(record.netProfitGrowth),
    eps: O.toNullable(record.eps),
    equity_ratio: O.toNullable(record.equityRatio),
    net_debt_to_ebit: O.toNullable(record.netDebtToEbit),
    net_debt_to_ebitda: O.toNullable(record.netDebtToEbitda),
    net_debt_to_equity: O.toNullable(record.netDebtToEquity),
    ev_to_ebit: O.toNullable(record.evToEbit),
    ev_to_ebitda: O.toNullable(record.evToEbitda),
    ev_to_net_sales: O.toNullable(record.evToNetSales),
    pe: O.toNullable(record.pe),
    ev: O.toNullable(record.ev),
    pbv: O.toNullable(record.pbv),
    annual_report_employee_growth: O.toNullable(record.annualReportEmployeeGrowth),
    active_jobposts: O.toNullable(record.activeJobposts),
    domain_is_verified: O.toNullable(record.domainIsVerified),
    domain: O.toNullable(record.domain),
    final_url: O.toNullable(record.finalUrl),
    error: O.toNullable(record.error),
    page_load_time_tti: O.toNullable(record.pageLoadTimeTti),
    domain_sys_period: O.toNullable(record.domainSysPeriod),
    ip_address: O.toNullable(record.ipAddress),
    analytics_ua: O.toNullable(record.analyticsUa),
    analytics_ga4: O.toNullable(record.analyticsGa4),
    analytics_fb: O.toNullable(record.analyticsFb),
    gconvp_account: O.toNullable(record.gconvpAccount),
    adobe_account: O.toNullable(record.adobeAccount),
    org_image: O.toNullable(record.orgImage),
    sitemaps: O.toNullable(record.sitemaps),
    cookie_consent: O.toNullable(record.cookieConsent),
    platform: O.toNullable(record.platform),
    server: O.toNullable(record.server),
    host: O.toNullable(record.host),
    domain_keywords: O.toNullable(record.domainKeywords),
    description: O.toNullable(record.description),
    description_words: O.toNullable(record.descriptionWords),
    description_chars: O.toNullable(record.descriptionChars),
    hosting_provider: O.toNullable(record.hostingProvider),
    hosting_region: O.toNullable(record.hostingRegion),
    is_ecommerce: O.toNullable(record.isEcommerce),
    ecommerce_platform: O.toNullable(record.ecommercePlatform),
    tool_cookiebot: O.toNullable(record.toolCookiebot),
    tool_cookielaw: O.toNullable(record.toolCookielaw),
    tool_onetrust: O.toNullable(record.toolOnetrust),
    tool_doubleclick: O.toNullable(record.toolDoubleclick),
    tool_hotjar: O.toNullable(record.toolHotjar),
    tool_optimizely: O.toNullable(record.toolOptimizely),
    tool_ebbot: O.toNullable(record.toolEbbot),
    tool_intercom: O.toNullable(record.toolIntercom),
    tool_klaviyo: O.toNullable(record.toolKlaviyo),
    tool_hubspot: O.toNullable(record.toolHubspot),
    tool_marketo: O.toNullable(record.toolMarketo),
    tool_salesforce: O.toNullable(record.toolSalesforce),
    tool_trustpilot: O.toNullable(record.toolTrustpilot),
    tool_custobar: O.toNullable(record.toolCustobar),
    tool_voyado: O.toNullable(record.toolVoyado),
    tool_godaddy: O.toNullable(record.toolGodaddy),
    tool_shopify: O.toNullable(record.toolShopify),
    tool_squarespace: O.toNullable(record.toolSquarespace),
    tool_wix: O.toNullable(record.toolWix),
    tool_wordpress: O.toNullable(record.toolWordpress),
    tool_seenthis: O.toNullable(record.toolSeenthis),
    tool_yotpo: O.toNullable(record.toolYotpo),
    tool_apprl: O.toNullable(record.toolApprl),
    tool_criteo: O.toNullable(record.toolCriteo),
    tool_reco: O.toNullable(record.toolReco),
    requested_hosts: O.toNullable(record.requestedHosts),
    analytics_gtm: O.toNullable(record.analyticsGtm),
    analytics_aw: O.toNullable(record.analyticsAw),
    tool_googletagmanager: O.toNullable(record.toolGoogletagmanager),
    size_document: O.toNullable(record.sizeDocument),
    size_script: O.toNullable(record.sizeScript),
    size_stylesheet: O.toNullable(record.sizeStylesheet),
    size_image: O.toNullable(record.sizeImage),
    size_media: O.toNullable(record.sizeMedia),
    title: O.toNullable(record.title),
    title_words: O.toNullable(record.titleWords),
    title_chars: O.toNullable(record.titleChars),
    favicon: O.toNullable(record.favicon),
    canonical: O.toNullable(record.canonical),
    robots: O.toNullable(record.robots),
    noindex: O.toNullable(record.noindex),
    internal_links: O.toNullable(record.internalLinks),
    external_links: O.toNullable(record.externalLinks),
    analytics_mo: O.toNullable(record.analyticsMo),
    lang: O.toNullable(record.lang),
    analytics_adobe: O.toNullable(record.analyticsAdobe),
    colors_font: O.toNullable(record.colorsFont),
    colors_page: O.toNullable(record.colorsPage),
    colors_svg: O.toNullable(record.colorsSvg),
    access_violation_score: O.toNullable(record.accessViolationScore),
    violations: O.toNullable(record.violations),
    img_alt_ratio: O.toNullable(record.imgAltRatio),
    analytics_opt: O.toNullable(record.analyticsOpt),
    analytics_amplitude: O.toNullable(record.analyticsAmplitude),
    analytics_snowplow: O.toNullable(record.analyticsSnowplow),
    trackers_before_consent: O.toNullable(record.trackersBeforeConsent),
    trackers_before_consent_count: O.toNullable(record.trackersBeforeConsentCount),
    web_vitals_ttfb: O.toNullable(record.webVitalsTtfb),
    web_vitals_fcp: O.toNullable(record.webVitalsFcp),
    web_vitals_lcp: O.toNullable(record.webVitalsLcp),
    web_vitals_cls: O.toNullable(record.webVitalsCls),
    web_vitals_tti: O.toNullable(record.webVitalsTti),
    web_vitals_inp: O.toNullable(record.webVitalsInp),
    detected_languages: O.toNullable(record.detectedLanguages),
    language_count: O.toNullable(record.languageCount),
    h_1_content: O.toNullable(record.h1Content),
    h_1_content_words: O.toNullable(record.h1ContentWords),
    h_1_content_chars: O.toNullable(record.h1ContentChars),
    h_1_count: O.toNullable(record.h1Count),
    h_2_count: O.toNullable(record.h2Count),
    h_3_count: O.toNullable(record.h3Count),
    sitemap: O.toNullable(record.sitemap),
    sitemap_count: O.toNullable(record.sitemapCount),
    sitemap_url_count: O.toNullable(record.sitemapUrlCount),
    dns_a: O.toNullable(record.dnsA),
    dns_aaaa: O.toNullable(record.dnsAaaa),
    dns_ns: O.toNullable(record.dnsNs),
    dns_soa: O.toNullable(record.dnsSoa),
    dns_mx: O.toNullable(record.dnsMx),
    email_provider: O.toNullable(record.emailProvider),
    dns_spf: O.toNullable(record.dnsSpf),
    dns_dmarc: O.toNullable(record.dnsDmarc),
    dns_dmarc_level: O.toNullable(record.dnsDmarcLevel),
    dns_dmarc_details: O.toNullable(record.dnsDmarcDetails),
    dns_dkim: O.toNullable(record.dnsDkim),
    dns_dkim_selector: O.toNullable(record.dnsDkimSelector),
    dns_dkim_level: O.toNullable(record.dnsDkimLevel),
    dns_dkim_details: O.toNullable(record.dnsDkimDetails),
    dns_verifications: O.toNullable(record.dnsVerifications),
    size_font: O.toNullable(record.sizeFont),
    size_xhr: O.toNullable(record.sizeXhr),
    size_ping: O.toNullable(record.sizePing),
    size_fetch: O.toNullable(record.sizeFetch),
    size_other: O.toNullable(record.sizeOther),
    x_robots_tag: O.toNullable(record.xRobotsTag),
    framework: O.toNullable(record.framework),
    cookies: O.toNullable(record.cookies),
    has_schema_script: O.toNullable(record.hasSchemaScript),
    img_count: O.toNullable(record.imgCount),
    img_alt_count: O.toNullable(record.imgAltCount),
    img_missing_alt_count: O.toNullable(record.imgMissingAltCount),
    img_title_count: O.toNullable(record.imgTitleCount),
    snapchat_handle: O.toNullable(record.snapchatHandle),
    linkedin_is_verified: O.toNullable(record.linkedinIsVerified),
    linkedin_id: O.toNullable(record.linkedinId),
    linkedin_domain: O.toNullable(record.linkedinDomain),
    linkedin_industry: O.toNullable(record.linkedinIndustry),
    linkedin_number_of_employees: O.toNullable(record.linkedinNumberOfEmployees),
    linkedin_all_employee_growth_3_months: O.toNullable(record.linkedinAllEmployeeGrowth3Months),
    linkedin_all_employee_growth_6_months: O.toNullable(record.linkedinAllEmployeeGrowth6Months),
    linkedin_all_employee_growth_1_year: O.toNullable(record.linkedinAllEmployeeGrowth1Year),
    linkedin_all_employee_growth_2_years: O.toNullable(record.linkedinAllEmployeeGrowth2Years),
    number_of_employees: O.toNullable(record.numberOfEmployees),
    number_of_employees_source: O.toNullable(record.numberOfEmployeesSource),
    identified_orgnr_count: O.toNullable(record.identifiedOrgnrCount),
    identified_orgnr_delta_6m: O.toNullable(record.identifiedOrgnrDelta6m),
    identified_orgnr_delta_1y: O.toNullable(record.identifiedOrgnrDelta1y),
    identified_orgnr_delta_3y: O.toNullable(record.identifiedOrgnrDelta3y),
    identified_orgnr_delta_5y: O.toNullable(record.identifiedOrgnrDelta5y),
    company_buzz_count: record.companyBuzzCount,
    company_buzz_is_raising_capital: O.toNullable(record.companyBuzzIsRaisingCapital),
    company_buzz_is_ipo: O.toNullable(record.companyBuzzIsIpo),
    company_buzz_is_merger: O.toNullable(record.companyBuzzIsMerger),
    company_buzz_is_moving: O.toNullable(record.companyBuzzIsMoving),
    company_buzz_is_hiring: O.toNullable(record.companyBuzzIsHiring),
    company_buzz_is_firing: O.toNullable(record.companyBuzzIsFiring),
    company_buzz_is_closing: O.toNullable(record.companyBuzzIsClosing),
    company_buzz_is_opening: O.toNullable(record.companyBuzzIsOpening),
    company_buzz_is_expanding: O.toNullable(record.companyBuzzIsExpanding),
    company_buzz_is_downsizing: O.toNullable(record.companyBuzzIsDownsizing),
    company_buzz_is_restructuring: O.toNullable(record.companyBuzzIsRestructuring),
    company_buzz_is_new_product_intro: O.toNullable(record.companyBuzzIsNewProductIntro),
    company_buzz_has_moved: O.toNullable(record.companyBuzzHasMoved),
    company_buzz_is_changing_ceo: O.toNullable(record.companyBuzzIsChangingCeo),
    company_buzz_is_changing_board: O.toNullable(record.companyBuzzIsChangingBoard),
    company_buzz_is_changing_management_team: O.toNullable(record.companyBuzzIsChangingManagementTeam),
    company_buzz_is_growth_geog: O.toNullable(record.companyBuzzIsGrowthGeog),
    company_buzz_is_growth_seg: O.toNullable(record.companyBuzzIsGrowthSeg),
    company_buzz_is_pricing_model: O.toNullable(record.companyBuzzIsPricingModel),
    company_buzz_is_partnership: O.toNullable(record.companyBuzzIsPartnership),
    company_buzz_is_m_and_a: O.toNullable(record.companyBuzzIsMAndA),
    company_buzz_is_divest: O.toNullable(record.companyBuzzIsDivest),
    company_buzz_is_cost_save: O.toNullable(record.companyBuzzIsCostSave),
    company_buzz_is_restruct: O.toNullable(record.companyBuzzIsRestruct),
    company_buzz_is_layoff: O.toNullable(record.companyBuzzIsLayoff),
    company_buzz_is_hire_plan: O.toNullable(record.companyBuzzIsHirePlan),
    company_buzz_is_leadership: O.toNullable(record.companyBuzzIsLeadership),
    company_buzz_is_capex_scale: O.toNullable(record.companyBuzzIsCapexScale),
    company_buzz_is_supply_chain: O.toNullable(record.companyBuzzIsSupplyChain),
    company_buzz_is_digi_ai: O.toNullable(record.companyBuzzIsDigiAi),
    company_buzz_is_esg_target: O.toNullable(record.companyBuzzIsEsgTarget),
    company_buzz_is_esg_event: O.toNullable(record.companyBuzzIsEsgEvent),
    company_buzz_is_reg_change: O.toNullable(record.companyBuzzIsRegChange),
    company_buzz_is_litigation: O.toNullable(record.companyBuzzIsLitigation),
    company_buzz_is_fin_raise: O.toNullable(record.companyBuzzIsFinRaise),
    company_buzz_is_div_policy: O.toNullable(record.companyBuzzIsDivPolicy),
    company_buzz_is_rev_guide: O.toNullable(record.companyBuzzIsRevGuide),
    company_buzz_is_rev_mix: O.toNullable(record.companyBuzzIsRevMix),
    company_buzz_is_cust_mega: O.toNullable(record.companyBuzzIsCustMega),
    company_buzz_is_risk_macro: O.toNullable(record.companyBuzzIsRiskMacro),
    ml_likely_to_move_probability: O.toNullable(record.mlLikelyToMoveProbability),
    ml_is_likely_to_move: O.toNullable(record.mlIsLikelyToMove),
    move_in_date_current_office: O.toNullable(record.moveInDateCurrentOffice),
    move_date_or_lease_expiration_date: O.toNullable(record.moveDateOrLeaseExpirationDate),
    move_date_or_lease_expiration_date_is_within_one_year: O.toNullable(record.moveDateOrLeaseExpirationDateIsWithinOneYear),
    move_date_or_lease_expiration_date_has_passed: O.toNullable(record.moveDateOrLeaseExpirationDateHasPassed),
    is_more_than_5_years_since_move_in_date_current_office: O.toNullable(record.isMoreThan5YearsSinceMoveInDateCurrentOffice),
    workspace_size_in_m2: O.toNullable(record.workspaceSizeInM2),
    workspace_size_in_m2_per_employee: O.toNullable(record.workspaceSizeInM2PerEmployee),
    nornorm_web_visitors_lead_quality: O.toNullable(record.nornormWebVisitorsLeadQuality),
    nornorm_web_visitors_number_of_visits: O.toNullable(record.nornormWebVisitorsNumberOfVisits),
    nornorm_web_visitors_country_code: O.toNullable(record.nornormWebVisitorsCountryCode),
    nornorm_web_visitors_last_visit_date: O.toNullable(record.nornormWebVisitorsLastVisitDate),
    nornorm_web_visitors_first_visit_date: O.toNullable(record.nornormWebVisitorsFirstVisitDate),
    active_jobposts_per_employee: O.toNullable(record.activeJobpostsPerEmployee),
    _6_sense_phone: O.toNullable(record._6SensePhone),
    _6_sense_city: O.toNullable(record._6SenseCity),
    _6_sense_description: O.toNullable(record._6SenseDescription),
    _6_sense_company_type: O.toNullable(record._6SenseCompanyType),
    _6_sense_industry: O.toNullable(record._6SenseIndustry),
    _6_sense_continent: O.toNullable(record._6SenseContinent),
    _6_sence_employee_range: O.toNullable(record._6SenceEmployeeRange),
    _6_sense_naics: O.toNullable(record._6SenseNaics),
    _6_sense_products_or_services: O.toNullable(record._6SenseProductsOrServices),
    _6_sense_sic: O.toNullable(record._6SenseSic),
    _6_sense_stock_exchange: O.toNullable(record._6SenseStockExchange),
    _6_sense_stock_symbol: O.toNullable(record._6SenseStockSymbol),
    _6_sense_web_technologies: O.toNullable(record._6SenseWebTechnologies),
    _6_sense_total_funding_range: O.toNullable(record._6SenseTotalFundingRange),
    _6_sense_year_founded: O.toNullable(record._6SenseYearFounded),
    percent_employees_with_more_than_10_years_experience: O.toNullable(record.percentEmployeesWithMoreThan10YearsExperience),
    has_on_site_requirements: O.toNullable(record.hasOnSiteRequirements),
    recent_funding: O.toNullable(record.recentFunding),
    nornorm_keyword_search: O.toNullable(record.nornormKeywordSearch),
    nornorm_researched_office: O.toNullable(record.nornormResearchedOffice),
    nornorm_researched_furniture: O.toNullable(record.nornormResearchedFurniture),
    looking_for_office: O.toNullable(record.lookingForOffice),
    is_sitting_on_co_working_space: O.toNullable(record.isSittingOnCoWorkingSpace),
    lease_expiration_date: O.toNullable(record.leaseExpirationDate),
    lease_expiration_date_is_within_one_year: O.toNullable(record.leaseExpirationDateIsWithinOneYear),
    nornorm_website_visitor: O.toNullable(record.nornormWebsiteVisitor),
    number_of_addresses: O.toNullable(record.numberOfAddresses),
    apollo_name: O.toNullable(record.apolloName),
    apollo_country: O.toNullable(record.apolloCountry),
    apollo_founded_year: O.toNullable(record.apolloFoundedYear),
    apollo_publicly_traded_symbol: O.toNullable(record.apolloPubliclyTradedSymbol),
    apollo_publicly_traded_exchange: O.toNullable(record.apolloPubliclyTradedExchange),
    apollo_latest_funding_stage: O.toNullable(record.apolloLatestFundingStage),
    apollo_latest_funding_round_date: O.toNullable(record.apolloLatestFundingRoundDate),
    apollo_total_funding: O.toNullable(record.apolloTotalFunding),
    apollo_total_funding_printed: O.toNullable(record.apolloTotalFundingPrinted),
    apollo_engineering_head_count_current: O.toNullable(record.apolloEngineeringHeadCountCurrent),
    apollo_sales_head_count_current: O.toNullable(record.apolloSalesHeadCountCurrent),
    apollo_support_head_count_current: O.toNullable(record.apolloSupportHeadCountCurrent),
    apollo_marketing_head_count_current: O.toNullable(record.apolloMarketingHeadCountCurrent),
    apollo_human_resources_head_count_current: O.toNullable(record.apolloHumanResourcesHeadCountCurrent),
    apollo_education_head_count_current: O.toNullable(record.apolloEducationHeadCountCurrent),
    apollo_media_and_communication_head_count_current: O.toNullable(record.apolloMediaAndCommunicationHeadCountCurrent),
    apollo_consulting_head_count_current: O.toNullable(record.apolloConsultingHeadCountCurrent),
    apollo_operations_head_count_current: O.toNullable(record.apolloOperationsHeadCountCurrent),
    apollo_finance_head_count_current: O.toNullable(record.apolloFinanceHeadCountCurrent),
    apollo_product_management_head_count_current: O.toNullable(record.apolloProductManagementHeadCountCurrent),
    apollo_business_development_head_count_current: O.toNullable(record.apolloBusinessDevelopmentHeadCountCurrent),
    apollo_information_technology_head_count_current: O.toNullable(record.apolloInformationTechnologyHeadCountCurrent),
    apollo_data_science_head_count_current: O.toNullable(record.apolloDataScienceHeadCountCurrent),
    apollo_arts_and_design_head_count_current: O.toNullable(record.apolloArtsAndDesignHeadCountCurrent),
    apollo_entrepreneurship_head_count_current: O.toNullable(record.apolloEntrepreneurshipHeadCountCurrent),
    apollo_administrative_head_count_current: O.toNullable(record.apolloAdministrativeHeadCountCurrent),
    apollo_legal_head_count_current: O.toNullable(record.apolloLegalHeadCountCurrent),
    apollo_accounting_head_count_current: O.toNullable(record.apolloAccountingHeadCountCurrent),
    apollo_total_head_count_current: O.toNullable(record.apolloTotalHeadCountCurrent),
    apollo_engineering_head_count_1_month_ago: O.toNullable(record.apolloEngineeringHeadCount1MonthAgo),
    apollo_sales_head_count_1_month_ago: O.toNullable(record.apolloSalesHeadCount1MonthAgo),
    apollo_support_head_count_1_month_ago: O.toNullable(record.apolloSupportHeadCount1MonthAgo),
    apollo_marketing_head_count_1_month_ago: O.toNullable(record.apolloMarketingHeadCount1MonthAgo),
    apollo_human_resources_head_count_1_month_ago: O.toNullable(record.apolloHumanResourcesHeadCount1MonthAgo),
    apollo_education_head_count_1_month_ago: O.toNullable(record.apolloEducationHeadCount1MonthAgo),
    apollo_media_and_communication_head_count_1_month_ago: O.toNullable(record.apolloMediaAndCommunicationHeadCount1MonthAgo),
    apollo_consulting_head_count_1_month_ago: O.toNullable(record.apolloConsultingHeadCount1MonthAgo),
    apollo_operations_head_count_1_month_ago: O.toNullable(record.apolloOperationsHeadCount1MonthAgo),
    apollo_finance_head_count_1_month_ago: O.toNullable(record.apolloFinanceHeadCount1MonthAgo),
    apollo_product_management_head_count_1_month_ago: O.toNullable(record.apolloProductManagementHeadCount1MonthAgo),
    apollo_business_development_head_count_1_month_ago: O.toNullable(record.apolloBusinessDevelopmentHeadCount1MonthAgo),
    apollo_information_technology_head_count_1_month_ago: O.toNullable(record.apolloInformationTechnologyHeadCount1MonthAgo),
    apollo_data_science_head_count_1_month_ago: O.toNullable(record.apolloDataScienceHeadCount1MonthAgo),
    apollo_arts_and_design_head_count_1_month_ago: O.toNullable(record.apolloArtsAndDesignHeadCount1MonthAgo),
    apollo_entrepreneurship_head_count_1_month_ago: O.toNullable(record.apolloEntrepreneurshipHeadCount1MonthAgo),
    apollo_administrative_head_count_1_month_ago: O.toNullable(record.apolloAdministrativeHeadCount1MonthAgo),
    apollo_legal_head_count_1_month_ago: O.toNullable(record.apolloLegalHeadCount1MonthAgo),
    apollo_accounting_head_count_1_month_ago: O.toNullable(record.apolloAccountingHeadCount1MonthAgo),
    apollo_total_head_count_1_month_ago: O.toNullable(record.apolloTotalHeadCount1MonthAgo),
    apollo_engineering_head_count_3_months_ago: O.toNullable(record.apolloEngineeringHeadCount3MonthsAgo),
    apollo_sales_head_count_3_months_ago: O.toNullable(record.apolloSalesHeadCount3MonthsAgo),
    apollo_support_head_count_3_months_ago: O.toNullable(record.apolloSupportHeadCount3MonthsAgo),
    apollo_marketing_head_count_3_months_ago: O.toNullable(record.apolloMarketingHeadCount3MonthsAgo),
    apollo_human_resources_head_count_3_months_ago: O.toNullable(record.apolloHumanResourcesHeadCount3MonthsAgo),
    apollo_education_head_count_3_months_ago: O.toNullable(record.apolloEducationHeadCount3MonthsAgo),
    apollo_media_and_communication_head_count_3_months_ago: O.toNullable(record.apolloMediaAndCommunicationHeadCount3MonthsAgo),
    apollo_consulting_head_count_3_months_ago: O.toNullable(record.apolloConsultingHeadCount3MonthsAgo),
    apollo_operations_head_count_3_months_ago: O.toNullable(record.apolloOperationsHeadCount3MonthsAgo),
    apollo_finance_head_count_3_months_ago: O.toNullable(record.apolloFinanceHeadCount3MonthsAgo),
    apollo_product_management_head_count_3_months_ago: O.toNullable(record.apolloProductManagementHeadCount3MonthsAgo),
    apollo_business_development_head_count_3_months_ago: O.toNullable(record.apolloBusinessDevelopmentHeadCount3MonthsAgo),
    apollo_information_technology_head_count_3_months_ago: O.toNullable(record.apolloInformationTechnologyHeadCount3MonthsAgo),
    apollo_data_science_head_count_3_months_ago: O.toNullable(record.apolloDataScienceHeadCount3MonthsAgo),
    apollo_arts_and_design_head_count_3_months_ago: O.toNullable(record.apolloArtsAndDesignHeadCount3MonthsAgo),
    apollo_entrepreneurship_head_count_3_months_ago: O.toNullable(record.apolloEntrepreneurshipHeadCount3MonthsAgo),
    apollo_administrative_head_count_3_months_ago: O.toNullable(record.apolloAdministrativeHeadCount3MonthsAgo),
    apollo_legal_head_count_3_months_ago: O.toNullable(record.apolloLegalHeadCount3MonthsAgo),
    apollo_accounting_head_count_3_months_ago: O.toNullable(record.apolloAccountingHeadCount3MonthsAgo),
    apollo_total_head_count_3_months_ago: O.toNullable(record.apolloTotalHeadCount3MonthsAgo),
    apollo_engineering_head_count_6_months_ago: O.toNullable(record.apolloEngineeringHeadCount6MonthsAgo),
    apollo_sales_head_count_6_months_ago: O.toNullable(record.apolloSalesHeadCount6MonthsAgo),
    apollo_support_head_count_6_months_ago: O.toNullable(record.apolloSupportHeadCount6MonthsAgo),
    apollo_marketing_head_count_6_months_ago: O.toNullable(record.apolloMarketingHeadCount6MonthsAgo),
    apollo_human_resources_head_count_6_months_ago: O.toNullable(record.apolloHumanResourcesHeadCount6MonthsAgo),
    apollo_education_head_count_6_months_ago: O.toNullable(record.apolloEducationHeadCount6MonthsAgo),
    apollo_media_and_communication_head_count_6_months_ago: O.toNullable(record.apolloMediaAndCommunicationHeadCount6MonthsAgo),
    apollo_consulting_head_count_6_months_ago: O.toNullable(record.apolloConsultingHeadCount6MonthsAgo),
    apollo_operations_head_count_6_months_ago: O.toNullable(record.apolloOperationsHeadCount6MonthsAgo),
    apollo_finance_head_count_6_months_ago: O.toNullable(record.apolloFinanceHeadCount6MonthsAgo),
    apollo_product_management_head_count_6_months_ago: O.toNullable(record.apolloProductManagementHeadCount6MonthsAgo),
    apollo_business_development_head_count_6_months_ago: O.toNullable(record.apolloBusinessDevelopmentHeadCount6MonthsAgo),
    apollo_information_technology_head_count_6_months_ago: O.toNullable(record.apolloInformationTechnologyHeadCount6MonthsAgo),
    apollo_data_science_head_count_6_months_ago: O.toNullable(record.apolloDataScienceHeadCount6MonthsAgo),
    apollo_arts_and_design_head_count_6_months_ago: O.toNullable(record.apolloArtsAndDesignHeadCount6MonthsAgo),
    apollo_entrepreneurship_head_count_6_months_ago: O.toNullable(record.apolloEntrepreneurshipHeadCount6MonthsAgo),
    apollo_administrative_head_count_6_months_ago: O.toNullable(record.apolloAdministrativeHeadCount6MonthsAgo),
    apollo_legal_head_count_6_months_ago: O.toNullable(record.apolloLegalHeadCount6MonthsAgo),
    apollo_accounting_head_count_6_months_ago: O.toNullable(record.apolloAccountingHeadCount6MonthsAgo),
    apollo_total_head_count_6_months_ago: O.toNullable(record.apolloTotalHeadCount6MonthsAgo),
    apollo_engineering_head_count_9_months_ago: O.toNullable(record.apolloEngineeringHeadCount9MonthsAgo),
    apollo_sales_head_count_9_months_ago: O.toNullable(record.apolloSalesHeadCount9MonthsAgo),
    apollo_support_head_count_9_months_ago: O.toNullable(record.apolloSupportHeadCount9MonthsAgo),
    apollo_marketing_head_count_9_months_ago: O.toNullable(record.apolloMarketingHeadCount9MonthsAgo),
    apollo_human_resources_head_count_9_months_ago: O.toNullable(record.apolloHumanResourcesHeadCount9MonthsAgo),
    apollo_education_head_count_9_months_ago: O.toNullable(record.apolloEducationHeadCount9MonthsAgo),
    apollo_media_and_communication_head_count_9_months_ago: O.toNullable(record.apolloMediaAndCommunicationHeadCount9MonthsAgo),
    apollo_consulting_head_count_9_months_ago: O.toNullable(record.apolloConsultingHeadCount9MonthsAgo),
    apollo_operations_head_count_9_months_ago: O.toNullable(record.apolloOperationsHeadCount9MonthsAgo),
    apollo_finance_head_count_9_months_ago: O.toNullable(record.apolloFinanceHeadCount9MonthsAgo),
    apollo_product_management_head_count_9_months_ago: O.toNullable(record.apolloProductManagementHeadCount9MonthsAgo),
    apollo_business_development_head_count_9_months_ago: O.toNullable(record.apolloBusinessDevelopmentHeadCount9MonthsAgo),
    apollo_information_technology_head_count_9_months_ago: O.toNullable(record.apolloInformationTechnologyHeadCount9MonthsAgo),
    apollo_data_science_head_count_9_months_ago: O.toNullable(record.apolloDataScienceHeadCount9MonthsAgo),
    apollo_arts_and_design_head_count_9_months_ago: O.toNullable(record.apolloArtsAndDesignHeadCount9MonthsAgo),
    apollo_entrepreneurship_head_count_9_months_ago: O.toNullable(record.apolloEntrepreneurshipHeadCount9MonthsAgo),
    apollo_administrative_head_count_9_months_ago: O.toNullable(record.apolloAdministrativeHeadCount9MonthsAgo),
    apollo_legal_head_count_9_months_ago: O.toNullable(record.apolloLegalHeadCount9MonthsAgo),
    apollo_accounting_head_count_9_months_ago: O.toNullable(record.apolloAccountingHeadCount9MonthsAgo),
    apollo_total_head_count_9_months_ago: O.toNullable(record.apolloTotalHeadCount9MonthsAgo),
    apollo_engineering_head_count_12_months_ago: O.toNullable(record.apolloEngineeringHeadCount12MonthsAgo),
    apollo_sales_head_count_12_months_ago: O.toNullable(record.apolloSalesHeadCount12MonthsAgo),
    apollo_support_head_count_12_months_ago: O.toNullable(record.apolloSupportHeadCount12MonthsAgo),
    apollo_marketing_head_count_12_months_ago: O.toNullable(record.apolloMarketingHeadCount12MonthsAgo),
    apollo_human_resources_head_count_12_months_ago: O.toNullable(record.apolloHumanResourcesHeadCount12MonthsAgo),
    apollo_education_head_count_12_months_ago: O.toNullable(record.apolloEducationHeadCount12MonthsAgo),
    apollo_media_and_communication_head_count_12_months_ago: O.toNullable(record.apolloMediaAndCommunicationHeadCount12MonthsAgo),
    apollo_consulting_head_count_12_months_ago: O.toNullable(record.apolloConsultingHeadCount12MonthsAgo),
    apollo_operations_head_count_12_months_ago: O.toNullable(record.apolloOperationsHeadCount12MonthsAgo),
    apollo_finance_head_count_12_months_ago: O.toNullable(record.apolloFinanceHeadCount12MonthsAgo),
    apollo_product_management_head_count_12_months_ago: O.toNullable(record.apolloProductManagementHeadCount12MonthsAgo),
    apollo_business_development_head_count_12_months_ago: O.toNullable(record.apolloBusinessDevelopmentHeadCount12MonthsAgo),
    apollo_information_technology_head_count_12_months_ago: O.toNullable(record.apolloInformationTechnologyHeadCount12MonthsAgo),
    apollo_data_science_head_count_12_months_ago: O.toNullable(record.apolloDataScienceHeadCount12MonthsAgo),
    apollo_arts_and_design_head_count_12_months_ago: O.toNullable(record.apolloArtsAndDesignHeadCount12MonthsAgo),
    apollo_entrepreneurship_head_count_12_months_ago: O.toNullable(record.apolloEntrepreneurshipHeadCount12MonthsAgo),
    apollo_administrative_head_count_12_months_ago: O.toNullable(record.apolloAdministrativeHeadCount12MonthsAgo),
    apollo_legal_head_count_12_months_ago: O.toNullable(record.apolloLegalHeadCount12MonthsAgo),
    apollo_accounting_head_count_12_months_ago: O.toNullable(record.apolloAccountingHeadCount12MonthsAgo),
    apollo_total_head_count_12_months_ago: O.toNullable(record.apolloTotalHeadCount12MonthsAgo),
    apollo_engineering_head_count_growth_1_month: O.toNullable(record.apolloEngineeringHeadCountGrowth1Month),
    apollo_sales_head_count_growth_1_month: O.toNullable(record.apolloSalesHeadCountGrowth1Month),
    apollo_support_head_count_growth_1_month: O.toNullable(record.apolloSupportHeadCountGrowth1Month),
    apollo_marketing_head_count_growth_1_month: O.toNullable(record.apolloMarketingHeadCountGrowth1Month),
    apollo_human_resources_head_count_growth_1_month: O.toNullable(record.apolloHumanResourcesHeadCountGrowth1Month),
    apollo_education_head_count_growth_1_month: O.toNullable(record.apolloEducationHeadCountGrowth1Month),
    apollo_media_and_communication_head_count_growth_1_month: O.toNullable(record.apolloMediaAndCommunicationHeadCountGrowth1Month),
    apollo_consulting_head_count_growth_1_month: O.toNullable(record.apolloConsultingHeadCountGrowth1Month),
    apollo_operations_head_count_growth_1_month: O.toNullable(record.apolloOperationsHeadCountGrowth1Month),
    apollo_finance_head_count_growth_1_month: O.toNullable(record.apolloFinanceHeadCountGrowth1Month),
    apollo_product_management_head_count_growth_1_month: O.toNullable(record.apolloProductManagementHeadCountGrowth1Month),
    apollo_business_development_head_count_growth_1_month: O.toNullable(record.apolloBusinessDevelopmentHeadCountGrowth1Month),
    apollo_information_technology_head_count_growth_1_month: O.toNullable(record.apolloInformationTechnologyHeadCountGrowth1Month),
    apollo_data_science_head_count_growth_1_month: O.toNullable(record.apolloDataScienceHeadCountGrowth1Month),
    apollo_arts_and_design_head_count_growth_1_month: O.toNullable(record.apolloArtsAndDesignHeadCountGrowth1Month),
    apollo_entrepreneurship_head_count_growth_1_month: O.toNullable(record.apolloEntrepreneurshipHeadCountGrowth1Month),
    apollo_administrative_head_count_growth_1_month: O.toNullable(record.apolloAdministrativeHeadCountGrowth1Month),
    apollo_legal_head_count_growth_1_month: O.toNullable(record.apolloLegalHeadCountGrowth1Month),
    apollo_accounting_head_count_growth_1_month: O.toNullable(record.apolloAccountingHeadCountGrowth1Month),
    apollo_total_head_count_growth_1_month: O.toNullable(record.apolloTotalHeadCountGrowth1Month),
    apollo_engineering_head_count_growth_3_months: O.toNullable(record.apolloEngineeringHeadCountGrowth3Months),
    apollo_sales_head_count_growth_3_months: O.toNullable(record.apolloSalesHeadCountGrowth3Months),
    apollo_support_head_count_growth_3_months: O.toNullable(record.apolloSupportHeadCountGrowth3Months),
    apollo_marketing_head_count_growth_3_months: O.toNullable(record.apolloMarketingHeadCountGrowth3Months),
    apollo_human_resources_head_count_growth_3_months: O.toNullable(record.apolloHumanResourcesHeadCountGrowth3Months),
    apollo_education_head_count_growth_3_months: O.toNullable(record.apolloEducationHeadCountGrowth3Months),
    apollo_media_and_communication_head_count_growth_3_months: O.toNullable(record.apolloMediaAndCommunicationHeadCountGrowth3Months),
    apollo_consulting_head_count_growth_3_months: O.toNullable(record.apolloConsultingHeadCountGrowth3Months),
    apollo_operations_head_count_growth_3_months: O.toNullable(record.apolloOperationsHeadCountGrowth3Months),
    apollo_finance_head_count_growth_3_months: O.toNullable(record.apolloFinanceHeadCountGrowth3Months),
    apollo_product_management_head_count_growth_3_months: O.toNullable(record.apolloProductManagementHeadCountGrowth3Months),
    apollo_business_development_head_count_growth_3_months: O.toNullable(record.apolloBusinessDevelopmentHeadCountGrowth3Months),
    apollo_information_technology_head_count_growth_3_months: O.toNullable(record.apolloInformationTechnologyHeadCountGrowth3Months),
    apollo_data_science_head_count_growth_3_months: O.toNullable(record.apolloDataScienceHeadCountGrowth3Months),
    apollo_arts_and_design_head_count_growth_3_months: O.toNullable(record.apolloArtsAndDesignHeadCountGrowth3Months),
    apollo_entrepreneurship_head_count_growth_3_months: O.toNullable(record.apolloEntrepreneurshipHeadCountGrowth3Months),
    apollo_administrative_head_count_growth_3_months: O.toNullable(record.apolloAdministrativeHeadCountGrowth3Months),
    apollo_legal_head_count_growth_3_months: O.toNullable(record.apolloLegalHeadCountGrowth3Months),
    apollo_accounting_head_count_growth_3_months: O.toNullable(record.apolloAccountingHeadCountGrowth3Months),
    apollo_total_head_count_growth_3_months: O.toNullable(record.apolloTotalHeadCountGrowth3Months),
    apollo_engineering_head_count_growth_6_months: O.toNullable(record.apolloEngineeringHeadCountGrowth6Months),
    apollo_sales_head_count_growth_6_months: O.toNullable(record.apolloSalesHeadCountGrowth6Months),
    apollo_support_head_count_growth_6_months: O.toNullable(record.apolloSupportHeadCountGrowth6Months),
    apollo_marketing_head_count_growth_6_months: O.toNullable(record.apolloMarketingHeadCountGrowth6Months),
    apollo_human_resources_head_count_growth_6_months: O.toNullable(record.apolloHumanResourcesHeadCountGrowth6Months),
    apollo_education_head_count_growth_6_months: O.toNullable(record.apolloEducationHeadCountGrowth6Months),
    apollo_media_and_communication_head_count_growth_6_months: O.toNullable(record.apolloMediaAndCommunicationHeadCountGrowth6Months),
    apollo_consulting_head_count_growth_6_months: O.toNullable(record.apolloConsultingHeadCountGrowth6Months),
    apollo_operations_head_count_growth_6_months: O.toNullable(record.apolloOperationsHeadCountGrowth6Months),
    apollo_finance_head_count_growth_6_months: O.toNullable(record.apolloFinanceHeadCountGrowth6Months),
    apollo_product_management_head_count_growth_6_months: O.toNullable(record.apolloProductManagementHeadCountGrowth6Months),
    apollo_business_development_head_count_growth_6_months: O.toNullable(record.apolloBusinessDevelopmentHeadCountGrowth6Months),
    apollo_information_technology_head_count_growth_6_months: O.toNullable(record.apolloInformationTechnologyHeadCountGrowth6Months),
    apollo_data_science_head_count_growth_6_months: O.toNullable(record.apolloDataScienceHeadCountGrowth6Months),
    apollo_arts_and_design_head_count_growth_6_months: O.toNullable(record.apolloArtsAndDesignHeadCountGrowth6Months),
    apollo_entrepreneurship_head_count_growth_6_months: O.toNullable(record.apolloEntrepreneurshipHeadCountGrowth6Months),
    apollo_administrative_head_count_growth_6_months: O.toNullable(record.apolloAdministrativeHeadCountGrowth6Months),
    apollo_legal_head_count_growth_6_months: O.toNullable(record.apolloLegalHeadCountGrowth6Months),
    apollo_accounting_head_count_growth_6_months: O.toNullable(record.apolloAccountingHeadCountGrowth6Months),
    apollo_total_head_count_growth_6_months: O.toNullable(record.apolloTotalHeadCountGrowth6Months),
    apollo_engineering_head_count_growth_9_months: O.toNullable(record.apolloEngineeringHeadCountGrowth9Months),
    apollo_sales_head_count_growth_9_months: O.toNullable(record.apolloSalesHeadCountGrowth9Months),
    apollo_support_head_count_growth_9_months: O.toNullable(record.apolloSupportHeadCountGrowth9Months),
    apollo_marketing_head_count_growth_9_months: O.toNullable(record.apolloMarketingHeadCountGrowth9Months),
    apollo_human_resources_head_count_growth_9_months: O.toNullable(record.apolloHumanResourcesHeadCountGrowth9Months),
    apollo_education_head_count_growth_9_months: O.toNullable(record.apolloEducationHeadCountGrowth9Months),
    apollo_media_and_communication_head_count_growth_9_months: O.toNullable(record.apolloMediaAndCommunicationHeadCountGrowth9Months),
    apollo_consulting_head_count_growth_9_months: O.toNullable(record.apolloConsultingHeadCountGrowth9Months),
    apollo_operations_head_count_growth_9_months: O.toNullable(record.apolloOperationsHeadCountGrowth9Months),
    apollo_finance_head_count_growth_9_months: O.toNullable(record.apolloFinanceHeadCountGrowth9Months),
    apollo_product_management_head_count_growth_9_months: O.toNullable(record.apolloProductManagementHeadCountGrowth9Months),
    apollo_business_development_head_count_growth_9_months: O.toNullable(record.apolloBusinessDevelopmentHeadCountGrowth9Months),
    apollo_information_technology_head_count_growth_9_months: O.toNullable(record.apolloInformationTechnologyHeadCountGrowth9Months),
    apollo_data_science_head_count_growth_9_months: O.toNullable(record.apolloDataScienceHeadCountGrowth9Months),
    apollo_arts_and_design_head_count_growth_9_months: O.toNullable(record.apolloArtsAndDesignHeadCountGrowth9Months),
    apollo_entrepreneurship_head_count_growth_9_months: O.toNullable(record.apolloEntrepreneurshipHeadCountGrowth9Months),
    apollo_administrative_head_count_growth_9_months: O.toNullable(record.apolloAdministrativeHeadCountGrowth9Months),
    apollo_legal_head_count_growth_9_months: O.toNullable(record.apolloLegalHeadCountGrowth9Months),
    apollo_accounting_head_count_growth_9_months: O.toNullable(record.apolloAccountingHeadCountGrowth9Months),
    apollo_total_head_count_growth_9_months: O.toNullable(record.apolloTotalHeadCountGrowth9Months),
    apollo_engineering_head_count_growth_12_months: O.toNullable(record.apolloEngineeringHeadCountGrowth12Months),
    apollo_sales_head_count_growth_12_months: O.toNullable(record.apolloSalesHeadCountGrowth12Months),
    apollo_support_head_count_growth_12_months: O.toNullable(record.apolloSupportHeadCountGrowth12Months),
    apollo_marketing_head_count_growth_12_months: O.toNullable(record.apolloMarketingHeadCountGrowth12Months),
    apollo_human_resources_head_count_growth_12_months: O.toNullable(record.apolloHumanResourcesHeadCountGrowth12Months),
    apollo_education_head_count_growth_12_months: O.toNullable(record.apolloEducationHeadCountGrowth12Months),
    apollo_media_and_communication_head_count_growth_12_months: O.toNullable(record.apolloMediaAndCommunicationHeadCountGrowth12Months),
    apollo_consulting_head_count_growth_12_months: O.toNullable(record.apolloConsultingHeadCountGrowth12Months),
    apollo_operations_head_count_growth_12_months: O.toNullable(record.apolloOperationsHeadCountGrowth12Months),
    apollo_finance_head_count_growth_12_months: O.toNullable(record.apolloFinanceHeadCountGrowth12Months),
    apollo_product_management_head_count_growth_12_months: O.toNullable(record.apolloProductManagementHeadCountGrowth12Months),
    apollo_business_development_head_count_growth_12_months: O.toNullable(record.apolloBusinessDevelopmentHeadCountGrowth12Months),
    apollo_information_technology_head_count_growth_12_months: O.toNullable(record.apolloInformationTechnologyHeadCountGrowth12Months),
    apollo_data_science_head_count_growth_12_months: O.toNullable(record.apolloDataScienceHeadCountGrowth12Months),
    apollo_arts_and_design_head_count_growth_12_months: O.toNullable(record.apolloArtsAndDesignHeadCountGrowth12Months),
    apollo_entrepreneurship_head_count_growth_12_months: O.toNullable(record.apolloEntrepreneurshipHeadCountGrowth12Months),
    apollo_administrative_head_count_growth_12_months: O.toNullable(record.apolloAdministrativeHeadCountGrowth12Months),
    apollo_legal_head_count_growth_12_months: O.toNullable(record.apolloLegalHeadCountGrowth12Months),
    apollo_accounting_head_count_growth_12_months: O.toNullable(record.apolloAccountingHeadCountGrowth12Months),
    apollo_total_head_count_growth_12_months: O.toNullable(record.apolloTotalHeadCountGrowth12Months),
    prv_applicant_has_trademark: O.toNullable(record.prvApplicantHasTrademark),
    prv_applicant_trademark_count_total: O.toNullable(record.prvApplicantTrademarkCountTotal),
    prv_applicant_trademark_count_active: O.toNullable(record.prvApplicantTrademarkCountActive),
    prv_applicant_trademarks_last_3m_count: O.toNullable(record.prvApplicantTrademarksLast3mCount),
    prv_applicant_trademarks_last_12m_count: O.toNullable(record.prvApplicantTrademarksLast12mCount),
    prv_applicant_applied_last_3m: O.toNullable(record.prvApplicantAppliedLast3m),
    prv_applicant_applied_last_12m: O.toNullable(record.prvApplicantAppliedLast12m),
    prv_applicant_latest_application_date: O.toNullable(record.prvApplicantLatestApplicationDate),
    prv_applicant_latest_status: O.toNullable(record.prvApplicantLatestStatus),
    prv_applicant_nice_classes: O.toNullable(record.prvApplicantNiceClasses),
    prv_applicant_nice_class_count: O.toNullable(record.prvApplicantNiceClassCount),
    prv_applicant_top_marks: O.toNullable(record.prvApplicantTopMarks),
    prv_applicant_next_renewal_date: O.toNullable(record.prvApplicantNextRenewalDate),
    prv_applicant_mapped_count: O.toNullable(record.prvApplicantMappedCount),
    prv_applicant_mapping_method: O.toNullable(record.prvApplicantMappingMethod),
    prv_applicant_last_mapped_at: O.toNullable(record.prvApplicantLastMappedAt),
});
exports.mapToMasterDataDBRecord = mapToMasterDataDBRecord;
//# sourceMappingURL=backend-fields.js.map